"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var $ = require("jquery");
var react_bootstrap_1 = require("react-bootstrap");
var AutoSuggest = require("react-autosuggest");
var react_chartjs_2_1 = require("react-chartjs-2");
var react_localization_1 = require("react-localization");
;
;
var localeStrings = "";
var localeStringsCustomer = "";
var flag = true;
var ISO3166_2 = {
    'AF': 'Afghanistan',
    'AL': 'Albania',
    'DZ': 'Algeria',
    'AS': 'American Samoa',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AI': 'Anguilla',
    'AQ': 'Antarctica',
    'AG': 'Antigua and Barbuda',
    'AR': 'Argentina',
    'AM': 'Armenia',
    'AW': 'Aruba',
    'AU': 'Australia',
    'AT': 'Austria',
    'AZ': 'Azerbaijan',
    'BS': 'Bahamas',
    'BH': 'Bahrain',
    'BD': 'Bangladesh',
    'BB': 'Barbados',
    'BY': 'Belarus',
    'BE': 'Belgium',
    'BZ': 'Belize',
    'BJ': 'Benin',
    'BM': 'Bermuda',
    'BT': 'Bhutan',
    'BO': 'Bolivia',
    'BA': 'Bosnia and Herzegovina',
    'BW': 'Botswana',
    'BV': 'Bouvet Island',
    'BR': 'Brazil',
    'BN': 'Brunei Darussalam',
    'BG': 'Bulgaria',
    'BF': 'Burkina Faso',
    'BI': 'Burundi',
    'KH': 'Cambodia',
    'CM': 'Cameroon',
    'CA': 'Canada',
    'CV': 'Cape Verde',
    'KY': 'Cayman Islands',
    'CF': 'Central African Republic',
    'TD': 'Chad',
    'CL': 'Chile',
    'CN': 'China',
    'CX': 'Christmas Island',
    'CC': 'Cocos Islands',
    'CO': 'Colombia',
    'KM': 'Comoros',
    'CG': 'Congo',
    'CD': 'Congo',
    'CK': 'Cook Islands',
    'CR': 'Costa Rica',
    'HR': 'Croatia',
    'CU': 'Cuba',
    'CY': 'Cyprus',
    'CZ': 'Czech Republic',
    'DK': 'Denmark',
    'DJ': 'Djibouti',
    'DM': 'Dominica',
    'DO': 'Dominican Republic',
    'EC': 'Ecuador',
    'EG': 'Egypt',
    'SV': 'El Salvador',
    'GQ': 'Equatorial Guinea',
    'ER': 'Eritrea',
    'EE': 'Estonia',
    'ET': 'Ethiopia',
    'FK': 'Falkland Islands',
    'FO': 'Faroe Islands',
    'FJ': 'Fiji',
    'FI': 'Finland',
    'FR': 'France',
    'GF': 'French Guiana',
    'PF': 'French Polynesia',
    'GA': 'Gabon',
    'GM': 'Gambia',
    'GE': 'Georgia',
    'DE': 'Germany',
    'GH': 'Ghana',
    'GI': 'Gibraltar',
    'GR': 'Greece',
    'GL': 'Greenland',
    'GD': 'Grenada',
    'GP': 'Guadeloupe',
    'GU': 'Guam',
    'GT': 'Guatemala',
    'GG': 'Guernsey',
    'GN': 'Guinea',
    'GW': 'Guinea-Bissau',
    'GY': 'Guyana',
    'HT': 'Haiti',
    'VA': 'Vatican',
    'HN': 'Honduras',
    'HK': 'Hong Kong',
    'HU': 'Hungary',
    'IS': 'Iceland',
    'IN': 'India',
    'ID': 'Indonesia',
    'IR': 'Iran',
    'IQ': 'Iraq',
    'IE': 'Ireland',
    'IM': 'Isle of Man',
    'IL': 'Israel',
    'IT': 'Italy',
    'JM': 'Jamaica',
    'JP': 'Japan',
    'JE': 'Jersey',
    'JO': 'Jordan',
    'KZ': 'Kazakhstan',
    'KE': 'Kenya',
    'KI': 'Kiribati',
    'KP': 'North Korea',
    'KR': 'South Korea',
    'KW': 'Kuwait',
    'KG': 'Kyrgyzstan',
    'LA': 'Laos',
    'LV': 'Latvia',
    'LB': 'Lebanon',
    'LS': 'Lesotho',
    'LR': 'Liberia',
    'LY': 'Libya',
    'LI': 'Liechtenstein',
    'LT': 'Lithuania',
    'LU': 'Luxembourg',
    'MO': 'Macao',
    'MK': 'Macedonia',
    'MG': 'Madagascar',
    'MW': 'Malawi',
    'MY': 'Malaysia',
    'MV': 'Maldives',
    'ML': 'Mali',
    'MT': 'Malta',
    'MH': 'Marshall Islands',
    'MQ': 'Martinique',
    'MR': 'Mauritania',
    'MU': 'Mauritius',
    'YT': 'Mayotte',
    'MX': 'Mexico',
    'FM': 'Micronesia',
    'MD': 'Moldova',
    'MC': 'Monaco',
    'MN': 'Mongolia',
    'ME': 'Montenegro',
    'MS': 'Montserrat',
    'MA': 'Morocco',
    'MZ': 'Mozambique',
    'MM': 'Myanmar',
    'NA': 'Namibia',
    'NR': 'Nauru',
    'NP': 'Nepal',
    'NL': 'Netherlands',
    'NC': 'New Caledonia',
    'NZ': 'New Zealand',
    'NI': 'Nicaragua',
    'NE': 'Niger',
    'NG': 'Nigeria',
    'NU': 'Niue',
    'NF': 'Norfolk Island',
    'MP': 'Northern Mariana Islands',
    'NO': 'Norway',
    'OM': 'Oman',
    'PK': 'Pakistan',
    'PW': 'Palau',
    'PS': 'Palestine',
    'PA': 'Panama',
    'PG': 'Papua New Guinea',
    'PY': 'Paraguay',
    'PE': 'Peru',
    'PH': 'Philippines',
    'PN': 'Pitcairn',
    'PL': 'Poland',
    'PT': 'Portugal',
    'PR': 'Puerto Rico',
    'QA': 'Qatar',
    'RE': 'RÃ©union',
    'RO': 'Romania',
    'RU': 'Russian Federation',
    'RW': 'Rwanda',
    'KN': 'Saint Kitts and Nevis',
    'LC': 'Saint Lucia',
    'MF': 'Saint Martin',
    'WS': 'Samoa',
    'SM': 'San Marino',
    'ST': 'Sao Tome and Principe',
    'SA': 'Saudi Arabia',
    'SN': 'Senegal',
    'RS': 'Serbia',
    'SC': 'Seychelles',
    'SL': 'Sierra Leone',
    'SG': 'Singapore',
    'SX': 'Sint Maarten',
    'SK': 'Slovakia',
    'SI': 'Slovenia',
    'SB': 'Solomon Islands',
    'SO': 'Somalia',
    'ZA': 'South Africa',
    'SS': 'South Sudan',
    'ES': 'Spain',
    'LK': 'Sri Lanka',
    'SD': 'Sudan',
    'SR': 'Suriname',
    'SJ': 'Svalbard and Jan Mayen',
    'SZ': 'Swaziland',
    'SE': 'Sweden',
    'CH': 'Switzerland',
    'SY': 'Syrian Arab Republic',
    'TW': 'Taiwan',
    'TJ': 'Tajikistan',
    'TZ': 'Tanzania',
    'TH': 'Thailand',
    'TL': 'Timor-Leste',
    'TG': 'Togo',
    'TK': 'Tokelau',
    'TO': 'Tonga',
    'TT': 'Trinidad and Tobago',
    'TN': 'Tunisia',
    'TR': 'Turkey',
    'TM': 'Turkmenistan',
    'TC': 'Turks and Caicos Islands',
    'TV': 'Tuvalu',
    'UG': 'Uganda',
    'UA': 'Ukraine',
    'AE': 'United Arab Emirates',
    'GB': 'United Kingdom',
    'US': 'United States',
    'UY': 'Uruguay',
    'UZ': 'Uzbekistan',
    'VU': 'Vanuatu',
    'VE': 'Venezuela',
    'VN': 'Viet Nam',
    'VG': 'Virgin Islands',
    'VI': 'Virgin Islands',
    'WF': 'Wallis and Futuna',
    'EH': 'Western Sahara',
    'YE': 'Yemen',
    'ZM': 'Zambia',
    'ZW': 'Zimbabwe'
};
function prependCountryName(ISO3166_2_code) {
    var obj = Object(ISO3166_2);
    if (ISO3166_2.hasOwnProperty(ISO3166_2_code)) {
        return ISO3166_2[ISO3166_2_code] + " (" + ISO3166_2_code + ")";
    }
    else {
        return ISO3166_2_code;
    }
}
// levenshtein distance
function getEditDistance(a, b) {
    if (a.length == 0)
        return b.length;
    if (b.length == 0)
        return a.length;
    var matrix = [];
    // increment along the first column of each row
    var i;
    for (i = 0; i <= b.length; i++) {
        matrix[i] = [i];
    }
    // increment each column in the first row
    var j;
    for (j = 0; j <= a.length; j++) {
        matrix[0][j] = j;
    }
    // Fill in the rest of the matrix
    for (i = 1; i <= b.length; i++) {
        for (j = 1; j <= a.length; j++) {
            if (b.charAt(i - 1) == a.charAt(j - 1)) {
                matrix[i][j] = matrix[i - 1][j - 1];
            }
            else {
                matrix[i][j] = Math.min(matrix[i - 1][j - 1] + 1, // substitution
                Math.min(matrix[i][j - 1] + 1, // insertion
                matrix[i - 1][j] + 1)); // deletion
            }
        }
    }
    return matrix[b.length][a.length];
}
var CustomerSelector = /** @class */ (function (_super) {
    __extends(CustomerSelector, _super);
    function CustomerSelector() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomerSelector.prototype.render = function () {
        return (React.createElement("select", { value: this.props.selectedCustomer, onChange: this.handleChange.bind(this) },
            React.createElement("option", { disabled: true, value: "selectCustomer" }, " --select a customer-- "),
            this.props.customers.map(function (customer, i) {
                return React.createElement("option", { value: customer, key: i }, customer);
            }),
            "; }"));
    };
    CustomerSelector.prototype.handleChange = function (e) {
        this.props.callback(e.target.value);
    };
    return CustomerSelector;
}(React.Component));
//---------------------------------------------------------------------------------
//---------------------------------------------------------------------------------
//---------------------------------------------------------------------------------
var CustomerSearcher = /** @class */ (function (_super) {
    __extends(CustomerSearcher, _super);
    function CustomerSearcher(props) {
        var _this = _super.call(this, props) || this;
        // Autosuggest is a controlled component. 
        // This means that you need to provide an input value 
        // and an onChange handler that updates this value (see below). 
        // Suggestions also need to be provided to the Autosuggest, 
        // and they are initially empty because the Autosuggest is closed. 
        _this.state = {
            value: '',
            suggestions: []
        };
        _this.getSuggestions = _this.getSuggestions.bind(_this);
        _this.getSuggestionValue = _this.getSuggestionValue.bind(_this);
        _this.renderSuggestion = _this.renderSuggestion.bind(_this);
        _this.onSuggestionSelected = _this.onSuggestionSelected.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onSuggestionsFetchRequested = _this.onSuggestionsFetchRequested.bind(_this);
        _this.onSuggestionsClearRequested = _this.onSuggestionsClearRequested.bind(_this);
        return _this;
    }
    CustomerSearcher.prototype.changeValue = function (newValue) {
        this.setState({
            value: newValue
        });
    };
    // Teach Autosuggest how to calculate suggestions for any given input value. 
    CustomerSearcher.prototype.getSuggestions = function (value) {
        // getEditDistance
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        if (inputLength === 0)
            return [];
        var suggestedCustomers = this.props.customers.filter(function (state) {
            return state.toLowerCase().slice(0, inputLength) === inputValue;
        });
        if (suggestedCustomers.length < 10) {
            var additionalCustomersNeeded = 10 - suggestedCustomers.length;
            var additionalCustomers = this.props.customers.filter(function (c) { return c.toLowerCase().indexOf(inputValue) !== -1; }).slice(0, additionalCustomersNeeded);
            suggestedCustomers = suggestedCustomers.concat(additionalCustomers);
        }
        if (suggestedCustomers.length === 0) {
            var additionalCustomersNeeded = 10 - suggestedCustomers.length;
            var additionalCustomers = this.props.customers
                .map(function (c) { return { customer: c, distance: getEditDistance(c.toLowerCase(), inputValue) }; })
                .sort(function (a, b) { return a.distance - b.distance; }).slice(0, 10).map(function (c) { return c.customer; });
            suggestedCustomers = suggestedCustomers.concat(additionalCustomers);
        }
        var finalCustomersList = Array.from(new Set(suggestedCustomers));
        return finalCustomersList;
    };
    // When suggestion is clicked, Autosuggest needs to populate the input field 
    // based on the clicked suggestion. Teach Autosuggest how to calculate the 
    // input value for every given suggestion. 
    CustomerSearcher.prototype.getSuggestionValue = function (suggestion) {
        return suggestion;
    };
    // Use your imagination to render suggestions. 
    CustomerSearcher.prototype.renderSuggestion = function (suggestion) {
        return (React.createElement("span", null, suggestion));
    };
    CustomerSearcher.prototype.onChange = function (event, _a) {
        var newValue = _a.newValue;
        this.setState({
            value: newValue
        });
    };
    // Autosuggest will call this function every time you need to update suggestions. 
    // You already implemented this logic above, so just use it. 
    CustomerSearcher.prototype.onSuggestionsFetchRequested = function (_a) {
        var value = _a.value;
        this.setState({
            suggestions: this.getSuggestions(value)
        });
    };
    // Autosuggest will call this function every time you need to clear suggestions. 
    CustomerSearcher.prototype.onSuggestionsClearRequested = function () {
        this.setState({
            suggestions: []
        });
    };
    CustomerSearcher.prototype.onSuggestionSelected = function (event, _a) {
        var suggestion = _a.suggestion, suggestionValue = _a.suggestionValue, sectionIndex = _a.sectionIndex, method = _a.method;
        this.props.callback(suggestionValue);
    };
    CustomerSearcher.prototype.render = function () {
        var _a = this.state, value = _a.value, suggestions = _a.suggestions;
        var Type_customer_name = localeStrings['Type_customer_name'];
        // Autosuggest will pass through all these props to the input field. 
        var inputProps = {
            placeholder: Type_customer_name,
            value: value,
            onChange: this.onChange
        };
        // Finally, render it! 
        return (React.createElement(AutoSuggest, { suggestions: suggestions, onSuggestionsClearRequested: this.onSuggestionsClearRequested, onSuggestionsFetchRequested: this.onSuggestionsFetchRequested, onSuggestionSelected: this.onSuggestionSelected, getSuggestionValue: this.getSuggestionValue, renderSuggestion: this.renderSuggestion, inputProps: inputProps, highlightFirstSuggestion: true }));
    };
    return CustomerSearcher;
}(React.Component));
;
var categories = {
    'OK': { 'label': localeStrings['ok_label'], 'desc': localeStrings['ok_description'], 'style': 'printer-status-ok' },
    'Out-of-date': { 'label': localeStrings['Out_of_date_label'], 'desc': localeStrings['Out_of_date_desc'], 'style': 'printer-status-out-of-date' },
    'Out-of-support': { 'label': localeStrings['reactive_support'], 'desc': localeStrings['FW_has_no_known_security_bulletins_only_FW_fixes_addressing_prioritized_security_risks'], 'style': 'printer-status-out-of-support' },
    'Vulnerable': { 'label': localeStrings['Vulnerable_label'], 'desc': localeStrings['Vulnerable_desc'], 'style': 'printer-status-vulnerable' },
    'No Firmware': { 'label': localeStrings['No_Firmware_label'], 'desc': localeStrings['No_Firmware_desc'], 'style': 'printer-status-no-firmware' },
    'No data': { 'label': localeStrings['No_data_label'], 'desc': localeStrings['No_data_desc'], 'style': 'printer-status-no-data' },
    'Not evaluated': { 'label': localeStrings['Not_evaluated_label'], 'desc': localeStrings['Not_evaluated_desc'], 'style': 'printer-status-not-evaluated' }
};
function statusStyleClass(status) {
    switch (status) {
        case "Not evaluated":
        case "Vulnerable":
        case "Out-of-support":
        case "Out-of-date":
        case "No Firmware":
        case "No data":
        case "OK":
            return categories[status].style;
        case "Vulnerable (End of Support)":
        case "Vulnerable (Upgradeable)":
            return categories["Vulnerable"].style;
        default:
            return "";
    }
}
function statusLabel(status) {
    switch (status) {
        case "Not evaluated":
        case "Vulnerable":
        case "Out-of-support":
        case "Out-of-date":
        case "No Firmware":
        case "No data":
        case "OK":
            return categories[status].label;
        default:
            return "";
    }
}
function extractOwnProperties(obj) {
    var props = [];
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            props.push({
                name: key,
                value: obj[key]
            });
        }
    }
    return props;
}
function removeParentheticalComment(s) {
    var parenIndex = s.lastIndexOf('(');
    return ((parenIndex > 0) ? s.substring(0, parenIndex) : s).trim();
}
function retrieveParetheticalComment(s) {
    var leftParenPos = s.indexOf('(');
    if (leftParenPos >= 0) {
        var rightParenPos = s.lastIndexOf(')');
        if (rightParenPos > leftParenPos) {
            return s.substr(leftParenPos + 1, rightParenPos - leftParenPos - 1).trim();
        }
    }
    return null;
}
var SummaryView = /** @class */ (function (_super) {
    __extends(SummaryView, _super);
    function SummaryView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    SummaryView.prototype.render = function () {
        var counts = this.props.summaryViewCounts;
        // let totalWithNonHP = Number(extractOwnProperties(counts).map(p => p.value).reduce((a, b) => Number(a) + Number(b)));
        var totalvulnerable = counts.end_of_Support + counts.upgradeable;
        var totalNotEvaluated = counts.not_evaluated_because_firmware_version_missing
            + counts.not_evaluated_because_firmware_version_mismatch
            + counts.not_evaluated_because_firmware_version_not_recognized
            + counts.not_evaluated_because_model_not_recognized
            + counts.not_evaluated_because_model_not_yet_evaluated;
        var totalSamsung = counts.samsung_device;
        var totalHP = counts.ok + counts.end_of_Support + counts.no_firmware + counts.out_of_support + counts.out_of_date + counts.upgradeable;
        var totalNonHP = counts.non_hp_device;
        var total = totalHP + totalSamsung + totalNonHP + counts.no_data + totalNotEvaluated;
        var PCT = this.Percent;
        var labels = ['OK', 'Out-of-date', 'Reactive Support', 'Vulnerable', "No Firmware", 'No data', 'Not evaluated', 'Non-HP', 'Samsung'];
        var data = [counts.ok, counts.out_of_date, counts.out_of_support, totalvulnerable, counts.no_firmware, counts.no_data, totalNotEvaluated, totalNonHP, totalSamsung];
        var backgroundColor = ["#dff0d8", "#d9edf7", "#fcf8e3", "#f2dede", "#e3e3e3", "#e3e3e3", "#e3e3e3", "#D5D8DC", "#D5D8DC"];
        var pieData = {
            labels: labels,
            datasets: [{
                    backgroundColor: backgroundColor,
                    data: data
                }]
        };
        return (React.createElement("table", { key: "SummaryView", style: { width: "100%" } },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", { style: { width: "70%" } },
                        React.createElement("table", { className: "table table-condensed" },
                            React.createElement("thead", null,
                                React.createElement("tr", null,
                                    React.createElement("th", null, localeStrings['summary_status']),
                                    React.createElement("th", null, localeStrings['summary_Description']),
                                    React.createElement("th", { className: "text-right" }, localeStrings['summary_Devices']),
                                    React.createElement("th", { className: "text-right" }, localeStrings['summary_Percent']))),
                            React.createElement("tbody", null,
                                React.createElement("tr", { className: statusStyleClass("OK") },
                                    React.createElement("td", null, categories["OK"].label),
                                    React.createElement("td", null, categories["OK"].desc),
                                    React.createElement("td", { className: "text-right" }, counts.ok),
                                    React.createElement("td", { className: "text-right" }, PCT(counts.ok, total))),
                                React.createElement("tr", { className: statusStyleClass("Out-of-date") },
                                    React.createElement("td", null, categories["Out-of-date"].label),
                                    React.createElement("td", null, categories["Out-of-date"].desc),
                                    React.createElement("td", { className: "text-right" }, counts.out_of_date),
                                    React.createElement("td", { className: "text-right" }, PCT(counts.out_of_date, total))),
                                React.createElement("tr", { className: statusStyleClass("Out-of-support") },
                                    React.createElement("td", null, categories["Out-of-support"].label),
                                    React.createElement("td", null, categories["Out-of-support"].desc),
                                    React.createElement("td", { className: "text-right" }, counts.out_of_support),
                                    React.createElement("td", { className: "text-right" }, PCT(counts.out_of_support, total))),
                                React.createElement("tr", { className: statusStyleClass("Vulnerable") },
                                    React.createElement("td", null, categories["Vulnerable"].label),
                                    React.createElement("td", null,
                                        categories["Vulnerable"].desc,
                                        React.createElement("div", null,
                                            React.createElement("br", null),
                                            React.createElement("table", { className: "table-condensed" },
                                                React.createElement("tbody", null,
                                                    React.createElement("tr", { className: "trAdjust" },
                                                        React.createElement("td", { className: "tdAdjust" },
                                                            localeStrings['reactive_support'],
                                                            " "),
                                                        React.createElement("td", null, counts.end_of_Support)),
                                                    React.createElement("tr", { className: "trAdjust" },
                                                        React.createElement("td", { className: "tdAdjust" },
                                                            localeStrings['non_reactive_support'],
                                                            "  "),
                                                        React.createElement("td", null, counts.upgradeable)))))),
                                    React.createElement("td", { className: "text-right" }, totalvulnerable),
                                    React.createElement("td", { className: "text-right" }, PCT(totalvulnerable, total))),
                                React.createElement("tr", { className: statusStyleClass("No Firmware") },
                                    React.createElement("td", null, categories["No Firmware"].label),
                                    React.createElement("td", null, categories["No Firmware"].desc),
                                    React.createElement("td", { className: "text-right" }, counts.no_firmware),
                                    React.createElement("td", { className: "text-right" }, PCT(counts.no_firmware, total))),
                                React.createElement("tr", { className: "text" },
                                    React.createElement("td", null),
                                    React.createElement("td", null,
                                        React.createElement("strong", null, localeStrings['Total'])),
                                    React.createElement("td", null),
                                    React.createElement("td", null)),
                                React.createElement("tr", null,
                                    React.createElement("td", null, localeStrings['HP_Devices']),
                                    React.createElement("td", null),
                                    React.createElement("td", { className: "text-right" }, totalHP),
                                    React.createElement("td", { className: "text-right" }, this.Percent(totalHP, total))),
                                React.createElement("tr", null,
                                    React.createElement("td", null, localeStrings['Samsung_Devices']),
                                    React.createElement("td", null),
                                    React.createElement("td", { className: "text-right" }, totalSamsung),
                                    React.createElement("td", { className: "text-right" }, this.Percent(totalSamsung, total))),
                                React.createElement("tr", null,
                                    React.createElement("td", null, localeStrings['Non_HP_Devices']),
                                    React.createElement("td", null,
                                        React.createElement("button", { type: "button", className: "btn btn-info button", "data-toggle": "collapse", "data-target": "#nonHp" },
                                            "\u25BC ",
                                            localeStrings['Security_status_unknown']),
                                        React.createElement("div", { id: "nonHp", className: "collapse" },
                                            React.createElement("br", null),
                                            React.createElement("table", { className: "table table-condensed" },
                                                React.createElement("tbody", null,
                                                    React.createElement("th", null, localeStrings['Non_HP_Brand']),
                                                    React.createElement("th", null, localeStrings['Non_HP_Devices_']),
                                                    React.createElement("th", null, localeStrings['Percent_of_Non_HP_Total']),
                                                    counts.Ricoh > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Ricoh"),
                                                        React.createElement("td", null, counts.Ricoh),
                                                        React.createElement("td", null, PCT(counts.Ricoh, totalNonHP))) : '',
                                                    counts.Xerox > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Xerox"),
                                                        React.createElement("td", null, counts.Xerox),
                                                        React.createElement("td", null, PCT(counts.Xerox, totalNonHP))) : '',
                                                    counts.Dell > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Dell"),
                                                        React.createElement("td", null, counts.Dell),
                                                        React.createElement("td", null, PCT(counts.Dell, totalNonHP))) : '',
                                                    counts.OKI > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "OKI"),
                                                        React.createElement("td", null, counts.OKI),
                                                        React.createElement("td", null, PCT(counts.OKI, totalNonHP))) : '',
                                                    counts.Kyocera > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Kyocera"),
                                                        React.createElement("td", null, counts.Kyocera),
                                                        React.createElement("td", null, PCT(counts.Kyocera, totalNonHP))) : '',
                                                    counts.Printronix > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Printronix"),
                                                        React.createElement("td", null, counts.Printronix),
                                                        React.createElement("td", null, PCT(counts.Printronix, totalNonHP))) : '',
                                                    counts.Zebra > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Zebra"),
                                                        React.createElement("td", null, counts.Zebra),
                                                        React.createElement("td", null, PCT(counts.Zebra, totalNonHP))) : '',
                                                    counts.Lexmark > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Lexmark"),
                                                        React.createElement("td", null, counts.Lexmark),
                                                        React.createElement("td", null, PCT(counts.Lexmark, totalNonHP))) : '',
                                                    counts.Canon > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Canon"),
                                                        React.createElement("td", null, counts.Canon),
                                                        React.createElement("td", null, PCT(counts.Canon, totalNonHP))) : '',
                                                    counts.Toshiba > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Toshiba"),
                                                        React.createElement("td", null, counts.Toshiba),
                                                        React.createElement("td", null, PCT(counts.Toshiba, totalNonHP))) : '',
                                                    counts.TallyGenicom > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "TallyGenicom"),
                                                        React.createElement("td", null, counts.TallyGenicom),
                                                        React.createElement("td", null, PCT(counts.TallyGenicom, totalNonHP))) : '',
                                                    counts.Konica > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Konica"),
                                                        React.createElement("td", null, counts.Konica),
                                                        React.createElement("td", null, PCT(counts.Konica, totalNonHP))) : '',
                                                    counts.Epson > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Epson"),
                                                        React.createElement("td", null, counts.Epson),
                                                        React.createElement("td", null, PCT(counts.Epson, totalNonHP))) : '',
                                                    counts.Axis > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Axis"),
                                                        React.createElement("td", null, counts.Axis),
                                                        React.createElement("td", null, PCT(counts.Axis, totalNonHP))) : '',
                                                    counts.Okidata > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Okidata"),
                                                        React.createElement("td", null, counts.Okidata),
                                                        React.createElement("td", null, PCT(counts.Okidata, totalNonHP))) : '',
                                                    counts.Brady > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Brady"),
                                                        React.createElement("td", null, counts.Brady),
                                                        React.createElement("td", null, PCT(counts.Brady, totalNonHP))) : '',
                                                    counts.Brother > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Brother"),
                                                        React.createElement("td", null, counts.Brother),
                                                        React.createElement("td", null, PCT(counts.Brother, totalNonHP))) : '',
                                                    counts.Centronics > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Centronics"),
                                                        React.createElement("td", null, counts.Centronics),
                                                        React.createElement("td", null, PCT(counts.Centronics, totalNonHP))) : '',
                                                    counts.Oce > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Oce"),
                                                        React.createElement("td", null, counts.Oce),
                                                        React.createElement("td", null, PCT(counts.Oce, totalNonHP))) : '',
                                                    counts.LabelTac > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "LabelTac"),
                                                        React.createElement("td", null, counts.LabelTac),
                                                        React.createElement("td", null, PCT(counts.LabelTac, totalNonHP))) : '',
                                                    counts.Datamax > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Datamax"),
                                                        React.createElement("td", null, counts.Datamax),
                                                        React.createElement("td", null, PCT(counts.Datamax, totalNonHP))) : '',
                                                    counts.Dymo > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Dymo"),
                                                        React.createElement("td", null, counts.Dymo),
                                                        React.createElement("td", null, PCT(counts.Dymo, totalNonHP))) : '',
                                                    counts.Intermec > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Intermec"),
                                                        React.createElement("td", null, counts.Intermec),
                                                        React.createElement("td", null, PCT(counts.Intermec, totalNonHP))) : '',
                                                    counts.Savin > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Savin"),
                                                        React.createElement("td", null, counts.Savin),
                                                        React.createElement("td", null, PCT(counts.Savin, totalNonHP))) : '',
                                                    counts.Fujitsu > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Fujitsu"),
                                                        React.createElement("td", null, counts.Fujitsu),
                                                        React.createElement("td", null, PCT(counts.Fujitsu, totalNonHP))) : '',
                                                    counts.IBM > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "IBM"),
                                                        React.createElement("td", null, counts.IBM),
                                                        React.createElement("td", null, PCT(counts.IBM, totalNonHP))) : '',
                                                    counts.ilwoo > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "ilwoo"),
                                                        React.createElement("td", null, counts.ilwoo),
                                                        React.createElement("td", null, PCT(counts.ilwoo, totalNonHP))) : '',
                                                    counts.Kodak > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Kodak"),
                                                        React.createElement("td", null, counts.Kodak),
                                                        React.createElement("td", null, PCT(counts.Kodak, totalNonHP))) : '',
                                                    counts.Komdruck > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Komdruck"),
                                                        React.createElement("td", null, counts.Komdruck),
                                                        React.createElement("td", null, PCT(counts.Komdruck, totalNonHP))) : '',
                                                    counts.Muratec > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Muratec"),
                                                        React.createElement("td", null, counts.Muratec),
                                                        React.createElement("td", null, PCT(counts.Muratec, totalNonHP))) : '',
                                                    counts.Sharp > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Sharp"),
                                                        React.createElement("td", null, counts.Sharp),
                                                        React.createElement("td", null, PCT(counts.Sharp, totalNonHP))) : '',
                                                    counts.Panasonic > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Panasonic"),
                                                        React.createElement("td", null, counts.Panasonic),
                                                        React.createElement("td", null, PCT(counts.Panasonic, totalNonHP))) : '',
                                                    counts.PSI > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "PSI"),
                                                        React.createElement("td", null, counts.PSI),
                                                        React.createElement("td", null, PCT(counts.PSI, totalNonHP))) : '',
                                                    counts.Sato > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Sato"),
                                                        React.createElement("td", null, counts.Sato),
                                                        React.createElement("td", null, PCT(counts.Sato, totalNonHP))) : '',
                                                    counts.Sewon > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Sewon"),
                                                        React.createElement("td", null, counts.Sewon),
                                                        React.createElement("td", null, PCT(counts.Sewon, totalNonHP))) : '',
                                                    counts.Microplex > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Microplex"),
                                                        React.createElement("td", null, counts.Microplex),
                                                        React.createElement("td", null, PCT(counts.Microplex, totalNonHP))) : '',
                                                    counts.Source > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Source"),
                                                        React.createElement("td", null, counts.Source),
                                                        React.createElement("td", null, PCT(counts.Source, totalNonHP))) : '',
                                                    counts.Troy > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Troy"),
                                                        React.createElement("td", null, counts.Troy),
                                                        React.createElement("td", null, PCT(counts.Troy, totalNonHP))) : '',
                                                    counts.Utax > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "Utax"),
                                                        React.createElement("td", null, counts.Utax),
                                                        React.createElement("td", null, PCT(counts.Utax, totalNonHP))) : '',
                                                    counts.TallyGenicom_Printronix > 0 ? React.createElement("tr", null,
                                                        React.createElement("td", null, "TallyGenicom (Printronix)"),
                                                        React.createElement("td", null, counts.TallyGenicom_Printronix),
                                                        React.createElement("td", null, PCT(counts.TallyGenicom_Printronix, totalNonHP))) : '')))),
                                    React.createElement("td", { className: "text-right" }, totalNonHP),
                                    React.createElement("td", { className: "text-right" }, this.Percent(totalNonHP, total))),
                                React.createElement("tr", { className: statusStyleClass("No data") },
                                    React.createElement("td", null, categories["No data"].label),
                                    React.createElement("td", null, categories["No data"].desc),
                                    React.createElement("td", { className: "text-right" }, counts.no_data),
                                    React.createElement("td", { className: "text-right" }, PCT(counts.no_data, total))),
                                React.createElement("tr", { className: statusStyleClass("Not evaluated") },
                                    React.createElement("td", null, categories["Not evaluated"].label),
                                    React.createElement("td", null,
                                        React.createElement("button", { type: "button", className: "btn btn-info button", "data-toggle": "collapse", "data-target": "#demo" },
                                            "\u25BC ",
                                            categories["Not evaluated"].desc),
                                        React.createElement("div", { id: "demo", className: "collapse" },
                                            React.createElement("br", null),
                                            React.createElement("div", null,
                                                React.createElement("table", { className: "table table-condensed" },
                                                    React.createElement("tbody", null,
                                                        React.createElement("tr", null,
                                                            React.createElement("td", null,
                                                                localeStrings['model_not_yet_evaluated'],
                                                                " "),
                                                            React.createElement("td", null, counts.not_evaluated_because_model_not_yet_evaluated)),
                                                        React.createElement("tr", null,
                                                            React.createElement("td", null,
                                                                localeStrings['model_not_recognized'],
                                                                "  "),
                                                            React.createElement("td", null, counts.not_evaluated_because_model_not_recognized)),
                                                        React.createElement("tr", null,
                                                            React.createElement("td", null,
                                                                localeStrings['firmware_version_missing'],
                                                                "  "),
                                                            React.createElement("td", null, counts.not_evaluated_because_firmware_version_missing)),
                                                        React.createElement("tr", null,
                                                            React.createElement("td", null,
                                                                localeStrings['firmware_version_mismatch'],
                                                                "  "),
                                                            React.createElement("td", null, counts.not_evaluated_because_firmware_version_mismatch)),
                                                        React.createElement("tr", null,
                                                            React.createElement("td", null,
                                                                localeStrings['firmware_version_not_recognized'],
                                                                "  "),
                                                            React.createElement("td", null, counts.not_evaluated_because_firmware_version_not_recognized))))))),
                                    React.createElement("td", { className: "text-right" }, totalNotEvaluated),
                                    React.createElement("td", { className: "text-right" }, PCT(totalNotEvaluated, total))),
                                React.createElement("tr", null,
                                    React.createElement("td", null, localeStrings['All_Devices']),
                                    React.createElement("td", null, localeStrings['Both_HP_and_Non_HP_Devices']),
                                    React.createElement("td", { className: "text-right" }, total),
                                    React.createElement("td", { className: "text-right" }, this.Percent(total, total)))))),
                    React.createElement("td", { style: { width: "20" } }),
                    React.createElement("td", null,
                        React.createElement(react_chartjs_2_1.Pie, { data: pieData, height: 300, width: 300, options: { responsive: false, legend: { display: false } } }))))));
    };
    SummaryView.prototype.Percent = function (count, totalCount) {
        if (totalCount > 0)
            return ((count / totalCount) * 100).toFixed(0) + '%';
        else
            return '0%';
    };
    return SummaryView;
}(React.Component));
var SummaryTable = /** @class */ (function (_super) {
    __extends(SummaryTable, _super);
    function SummaryTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SummaryTable.prototype.render = function () {
        var summaryCounts = {
            ok: 0,
            out_of_date: 0,
            out_of_support: 0,
            no_firmware: 0,
            no_data: 0,
            end_of_Support: 0,
            upgradeable: 0,
            not_evaluated_because_model_not_yet_evaluated: 0,
            not_evaluated_because_model_not_recognized: 0,
            not_evaluated_because_firmware_version_missing: 0,
            not_evaluated_because_firmware_version_mismatch: 0,
            not_evaluated_because_firmware_version_not_recognized: 0,
            non_hp_device: 0,
            samsung_device: 0,
            other: 0,
            Ricoh: 0,
            Xerox: 0,
            Dell: 0,
            OKI: 0,
            Kyocera: 0,
            Printronix: 0,
            Zebra: 0,
            Lexmark: 0,
            Canon: 0,
            Toshiba: 0,
            TallyGenicom: 0,
            Konica: 0,
            Epson: 0,
            Axis: 0,
            Okidata: 0,
            Brady: 0,
            Brother: 0,
            Centronics: 0,
            Oce: 0,
            LabelTac: 0,
            Datamax: 0,
            Dymo: 0,
            Intermec: 0,
            Savin: 0,
            Fujitsu: 0,
            IBM: 0,
            ilwoo: 0,
            Kodak: 0,
            Komdruck: 0,
            Muratec: 0,
            Sharp: 0,
            Panasonic: 0,
            PSI: 0,
            Sato: 0,
            Sewon: 0,
            Microplex: 0,
            Source: 0,
            TallyGenicom_Printronix: 0,
            Troy: 0,
            Utax: 0,
        };
        this.props.filteredOnlyOnCountryAndRegionPrinters.forEach(function (printer, i) {
            switch (printer.status) {
                case 'OK':
                    summaryCounts.ok++;
                    break;
                case 'Out-of-date':
                    summaryCounts.out_of_date++;
                    break;
                case 'Out-of-support':
                    summaryCounts.out_of_support++;
                    break;
                case 'Vulnerable (End of Support)':
                    summaryCounts.end_of_Support++;
                    break;
                case 'Vulnerable (Upgradeable)':
                    summaryCounts.upgradeable++;
                    break;
                case 'No data':
                    summaryCounts.no_data++;
                    break;
                case 'Not evaluated (model not included yet)':
                    summaryCounts.not_evaluated_because_model_not_yet_evaluated++;
                    break;
                case 'Not evaluated (model not recognized)':
                    summaryCounts.not_evaluated_because_model_not_recognized++;
                    break;
                case 'Not evaluated (firmware version missing)':
                    summaryCounts.not_evaluated_because_firmware_version_missing++;
                    break;
                case 'Not evaluated (firmware version mismatch)':
                    summaryCounts.not_evaluated_because_firmware_version_mismatch++;
                    break;
                case 'Not evaluated (firmware version unrecognized)':
                    summaryCounts.not_evaluated_because_firmware_version_not_recognized++;
                    break;
                case 'NonHP':
                    summaryCounts.non_hp_device++;
                    break;
                case 'Samsung':
                    summaryCounts.samsung_device++;
                    break;
                case 'Ricoh':
                    summaryCounts.Ricoh++, summaryCounts.non_hp_device++;
                    break;
                case 'Xerox':
                    summaryCounts.Xerox++, summaryCounts.non_hp_device++;
                    break;
                case 'Dell':
                    summaryCounts.Dell++, summaryCounts.non_hp_device++;
                    break;
                case 'OKI':
                    summaryCounts.OKI++, summaryCounts.non_hp_device++;
                    break;
                case 'Kyocera':
                    summaryCounts.Kyocera++, summaryCounts.non_hp_device++;
                    break;
                case 'Printronix':
                    summaryCounts.Printronix++, summaryCounts.non_hp_device++;
                    break;
                case 'Zebra':
                    summaryCounts.Zebra++, summaryCounts.non_hp_device++;
                    break;
                case 'Lexmark':
                    summaryCounts.Lexmark++, summaryCounts.non_hp_device++;
                    break;
                case 'Canon':
                    summaryCounts.Canon++, summaryCounts.non_hp_device++;
                    break;
                case 'Toshiba':
                    summaryCounts.Toshiba++, summaryCounts.non_hp_device++;
                    break;
                case 'TallyGenicom':
                    summaryCounts.TallyGenicom++, summaryCounts.non_hp_device++;
                    break;
                case 'Konica':
                    summaryCounts.Konica++, summaryCounts.non_hp_device++;
                    break;
                case 'Epson':
                    summaryCounts.Epson++, summaryCounts.non_hp_device++;
                    break;
                case 'Axis':
                    summaryCounts.Axis++, summaryCounts.non_hp_device++;
                    break;
                case 'Okidata':
                    summaryCounts.Okidata++, summaryCounts.non_hp_device++;
                    break;
                case 'Brady':
                    summaryCounts.Brady++, summaryCounts.non_hp_device++;
                    break;
                case 'Brother':
                    summaryCounts.Brother++, summaryCounts.non_hp_device++;
                    break;
                case 'Centronics':
                    summaryCounts.Centronics++, summaryCounts.non_hp_device++;
                    break;
                case 'Oce':
                    summaryCounts.Oce++, summaryCounts.non_hp_device++;
                    break;
                case 'LabelTac':
                    summaryCounts.LabelTac++, summaryCounts.non_hp_device++;
                    break;
                case 'Datamax':
                    summaryCounts.Datamax++, summaryCounts.non_hp_device++;
                    break;
                case 'Dymo':
                    summaryCounts.Dymo++, summaryCounts.non_hp_device++;
                    break;
                case 'Intermec':
                    summaryCounts.Intermec++, summaryCounts.non_hp_device++;
                    break;
                case 'Savin':
                    summaryCounts.Savin++, summaryCounts.non_hp_device++;
                    break;
                case 'Fujitsu':
                    summaryCounts.Fujitsu++, summaryCounts.non_hp_device++;
                    break;
                case 'IBM':
                    summaryCounts.IBM++, summaryCounts.non_hp_device++;
                    break;
                case 'Ilwoo':
                    summaryCounts.ilwoo++, summaryCounts.non_hp_device++;
                    break;
                case 'Kodak':
                    summaryCounts.Kodak++, summaryCounts.non_hp_device++;
                    break;
                case 'Komdruck':
                    summaryCounts.Komdruck++, summaryCounts.non_hp_device++;
                    break;
                case 'Muratec':
                    summaryCounts.Muratec++, summaryCounts.non_hp_device++;
                    break;
                case 'Sharp':
                    summaryCounts.Sharp++, summaryCounts.non_hp_device++;
                    break;
                case 'Panasonic':
                    summaryCounts.Panasonic++, summaryCounts.non_hp_device++;
                    break;
                case 'PSI':
                    summaryCounts.PSI++, summaryCounts.non_hp_device++;
                    break;
                case 'Sato':
                    summaryCounts.Sato++, summaryCounts.non_hp_device++;
                    break;
                case 'Sewon':
                    summaryCounts.Sewon++, summaryCounts.non_hp_device++;
                    break;
                case 'Microplex':
                    summaryCounts.Microplex++, summaryCounts.non_hp_device++;
                    break;
                case 'Utax':
                    summaryCounts.Utax++, summaryCounts.non_hp_device++;
                    break;
                case 'Source':
                    summaryCounts.Source++, summaryCounts.non_hp_device++;
                    break;
                case 'Troy':
                    summaryCounts.Troy++, summaryCounts.non_hp_device++;
                    break;
                case 'TallyGenicom (Printronix)':
                    summaryCounts.TallyGenicom_Printronix++, summaryCounts.non_hp_device++;
                    break;
                default:
                    summaryCounts.other++;
                    break;
            }
        });
        return React.createElement(SummaryView, { summaryViewCounts: summaryCounts });
    };
    return SummaryTable;
}(React.Component));
var WorldWideSummaryTable = /** @class */ (function (_super) {
    __extends(WorldWideSummaryTable, _super);
    function WorldWideSummaryTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WorldWideSummaryTable.prototype.render = function () {
        var summaryCounts = {
            ok: 0,
            out_of_date: 0,
            out_of_support: 0,
            no_firmware: 0,
            end_of_Support: 0,
            upgradeable: 0,
            no_data: 0,
            not_evaluated_because_model_not_yet_evaluated: 0,
            not_evaluated_because_model_not_recognized: 0,
            not_evaluated_because_firmware_version_missing: 0,
            not_evaluated_because_firmware_version_mismatch: 0,
            not_evaluated_because_firmware_version_not_recognized: 0,
            non_hp_device: 0,
            samsung_device: 0,
            other: 1,
            Ricoh: 0,
            Xerox: 0,
            Dell: 0,
            OKI: 0,
            Kyocera: 0,
            Printronix: 0,
            Zebra: 0,
            Lexmark: 0,
            Canon: 0,
            Toshiba: 0,
            TallyGenicom: 0,
            Konica: 0,
            Epson: 0,
            Axis: 0,
            Okidata: 0,
            Brady: 0,
            Brother: 0,
            Centronics: 0,
            Oce: 0,
            LabelTac: 0,
            Datamax: 0,
            Dymo: 0,
            Intermec: 0,
            Savin: 0,
            Fujitsu: 0,
            IBM: 0,
            ilwoo: 0,
            Kodak: 0,
            Komdruck: 0,
            Muratec: 0,
            Sharp: 0,
            Panasonic: 0,
            PSI: 0,
            Sato: 0,
            Sewon: 0,
            Microplex: 0,
            Source: 0,
            TallyGenicom_Printronix: 0,
            Troy: 0,
            Utax: 0,
        };
        this.props.regionStatusCounts.forEach(function (rsc, i) {
            switch (rsc.status) {
                case 'OK':
                    summaryCounts.ok += rsc.count;
                    break;
                case 'Out-of-date':
                    summaryCounts.out_of_date += rsc.count;
                    break;
                case 'Out-of-support':
                    summaryCounts.out_of_support += rsc.count;
                    break;
                case 'No Firmware':
                    summaryCounts.no_firmware += rsc.count;
                    break;
                case 'Vulnerable (End of Support)':
                    summaryCounts.end_of_Support += rsc.count;
                    break;
                case 'Vulnerable (Upgradeable)':
                    summaryCounts.upgradeable += rsc.count;
                    break;
                case 'No data':
                    summaryCounts.no_data += rsc.count;
                    break;
                case 'Not evaluated (model not included yet)':
                    summaryCounts.not_evaluated_because_model_not_yet_evaluated += rsc.count;
                    break;
                case 'Not evaluated (model not recognized)':
                    summaryCounts.not_evaluated_because_model_not_recognized += rsc.count;
                    break;
                case 'Not evaluated (firmware version missing)':
                    summaryCounts.not_evaluated_because_firmware_version_missing += rsc.count;
                    break;
                case 'Not evaluated (firmware version mismatch)':
                    summaryCounts.not_evaluated_because_firmware_version_mismatch += rsc.count;
                    break;
                case 'Not evaluated (firmware version unrecognized)':
                    summaryCounts.not_evaluated_because_firmware_version_not_recognized += rsc.count;
                    break;
                case 'NonHP':
                    summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Ricoh':
                    summaryCounts.Ricoh += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Xerox':
                    summaryCounts.Xerox += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Dell':
                    summaryCounts.Dell += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'OKI':
                    summaryCounts.OKI += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Kyocera':
                    summaryCounts.Kyocera += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Printronix':
                    summaryCounts.Printronix += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Zebra':
                    summaryCounts.Zebra += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Lexmark':
                    summaryCounts.Lexmark += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Canon':
                    summaryCounts.Canon += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Toshiba':
                    summaryCounts.Toshiba += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'TallyGenicom':
                    summaryCounts.TallyGenicom += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Konica':
                    summaryCounts.Konica += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Epson':
                    summaryCounts.Epson += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Axis':
                    summaryCounts.Axis += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Okidata':
                    summaryCounts.Okidata += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Brady':
                    summaryCounts.Brady += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Brother':
                    summaryCounts.Brother += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Centronics':
                    summaryCounts.Centronics += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Oce':
                    summaryCounts.Oce += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'LabelTac':
                    summaryCounts.LabelTac += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Datamax':
                    summaryCounts.Datamax += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Dymo':
                    summaryCounts.Dymo += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Intermec':
                    summaryCounts.Intermec += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Savin':
                    summaryCounts.Savin += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Fujitsu':
                    summaryCounts.Fujitsu += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'IBM':
                    summaryCounts.IBM += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Ilwoo':
                    summaryCounts.ilwoo += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Kodak':
                    summaryCounts.Kodak += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Komdruck':
                    summaryCounts.Komdruck += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Muratec':
                    summaryCounts.Muratec += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Sharp':
                    summaryCounts.Sharp += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Panasonic':
                    summaryCounts.Panasonic += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'PSI':
                    summaryCounts.PSI += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Sato':
                    summaryCounts.Sato += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Sewon':
                    summaryCounts.Sewon += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Microplex':
                    summaryCounts.Microplex += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Utax':
                    summaryCounts.Utax += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Source':
                    summaryCounts.Source += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'TallyGenicom (Printronix)':
                    summaryCounts.TallyGenicom_Printronix += rsc.count, summaryCounts.non_hp_device += rsc.count;
                    break;
                case 'Samsung':
                    summaryCounts.samsung_device += rsc.count;
                    break;
                default:
                    summaryCounts.other += rsc.count;
                    break;
            }
        });
        return React.createElement(SummaryView, { summaryViewCounts: summaryCounts });
    };
    return WorldWideSummaryTable;
}(React.Component));
var PrintersTable = /** @class */ (function (_super) {
    __extends(PrintersTable, _super);
    function PrintersTable(props) {
        return _super.call(this, props) || this;
    }
    PrintersTable.prototype.render = function () {
        try {
            var renderStatus_1 = this.renderStatus;
            var renderStatusFWVerandRevOutofDate_1 = this.renderStatusFWVerandRevOutofDate;
            var rows_1 = [];
            this.props.filteredPrinters.forEach(function (printer, i) {
                rows_1.push(React.createElement("tr", { key: printer.prod_num + printer.serial_number, className: statusStyleClass(printer.status) },
                    renderStatus_1(printer.status),
                    React.createElement("td", null,
                        printer.serial_number,
                        React.createElement("br", null),
                        printer.ip_address),
                    React.createElement("td", null,
                        printer.prod_num,
                        React.createElement("br", null),
                        printer.prod_model),
                    React.createElement("td", null,
                        printer.dev_fw_ver,
                        React.createElement("br", null),
                        printer.dev_fw_ver_date),
                    (renderStatusFWVerandRevOutofDate_1(printer.status) == "Limited Reporting" && !printer.prod_model.includes('Samsung')) ? [(printer.latest_fw_ver == null) ? React.createElement("td", null,
                            " ",
                            "NA") : React.createElement("td", null,
                            printer.latest_fw_ver,
                            React.createElement("br", null),
                            printer.latest_fw_ver_date)] : React.createElement("td", null,
                        printer.latest_fw_ver,
                        React.createElement("br", null),
                        printer.latest_fw_ver_date),
                    (renderStatusFWVerandRevOutofDate_1(printer.status) == "Limited Reporting" && !printer.prod_model.includes('Samsung')) ? React.createElement("td", null,
                        " ",
                        "NA") : React.createElement("td", null, printer.revs_out_of_date),
                    React.createElement("td", null, printer.vulnerability_count),
                    React.createElement("td", null, printer.out_of_support),
                    React.createElement("td", null, printer.country_cd),
                    React.createElement("td", null, printer.geo_region_cd),
                    React.createElement("td", null, printer.city),
                    React.createElement("td", null, printer.state_province)));
            });
            return (React.createElement("table", { key: "PrintersTable", className: "table table-condensed table-bordered" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, localeStrings['Status']),
                        React.createElement("th", null, localeStrings['Device_ID']),
                        React.createElement("th", null, localeStrings['Product']),
                        React.createElement("th", null, localeStrings['Device_FW_Ver']),
                        React.createElement("th", null, localeStrings['Latest_FW_Ver']),
                        React.createElement("th", null, localeStrings['Revs_Out_of_Date']),
                        React.createElement("th", null, localeStrings['Bulletin_Count']),
                        React.createElement("th", null, localeStrings['reactive_support']),
                        React.createElement("th", null, localeStrings['CNTRY']),
                        React.createElement("th", null, localeStrings['REGION']),
                        React.createElement("th", null, localeStrings['CITY']),
                        React.createElement("th", null, localeStrings['STATE']))),
                React.createElement("tbody", null, rows_1)));
        }
        catch (e) {
            var xerces = 5;
        }
    };
    PrintersTable.prototype.renderStatus = function (status) {
        var baseStatus = removeParentheticalComment(status);
        var label = statusLabel(baseStatus);
        var comment = retrieveParetheticalComment(status);
        if (label == "") {
            label = "Limited Reporting";
            comment = "Not all fields may have information";
        }
        if (comment) {
            var tooltip = (React.createElement(react_bootstrap_1.Tooltip, { id: "tooltip" }, comment));
            return (React.createElement(react_bootstrap_1.OverlayTrigger, { placement: "right", overlay: tooltip },
                React.createElement("td", null, label)));
        }
        else {
            return (React.createElement("td", null, label));
        }
    };
    PrintersTable.prototype.renderStatusFWVerandRevOutofDate = function (status) {
        var baseStatus = removeParentheticalComment(status);
        var label = statusLabel(baseStatus);
        if (label == "") {
            return "Limited Reporting";
        }
    };
    return PrintersTable;
}(React.Component));
var VulnerabilitiesTable = /** @class */ (function (_super) {
    __extends(VulnerabilitiesTable, _super);
    function VulnerabilitiesTable(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.handleShow = _this.handleShow.bind(_this);
        _this.handleClose = _this.handleClose.bind(_this);
        _this.state = {
            show: false
        };
        return _this;
    }
    VulnerabilitiesTable.prototype.handleClose = function () {
        this.setState({ show: false });
    };
    VulnerabilitiesTable.prototype.handleShow = function () {
        this.setState({ show: true });
    };
    VulnerabilitiesTable.prototype.render = function () {
        var popover = (React.createElement(react_bootstrap_1.Popover, { id: "modal-popover", title: "popover" }, "very popover. such engagement"));
        var tooltip = React.createElement(react_bootstrap_1.Tooltip, { id: "modal-tooltip" }, "wow.");
        var rows = [];
        var filteredVulnerabilities = this.props.filteredVulnerabilities;
        filteredVulnerabilities.forEach(function (vulnerability, i) {
            rows.push(React.createElement("tr", { key: i, className: statusStyleClass("Vulnerable") },
                React.createElement("td", null, localeStrings['Vulnerable_label']),
                React.createElement("td", null,
                    vulnerability.serial_number,
                    React.createElement("br", null),
                    vulnerability.ip_address),
                React.createElement("td", null,
                    vulnerability.prod_num,
                    React.createElement("br", null),
                    vulnerability.prod_model),
                React.createElement("td", null,
                    vulnerability.dev_fw_ver,
                    React.createElement("br", null),
                    vulnerability.dev_fw_ver_date),
                React.createElement("td", null,
                    vulnerability.resolved_fw_ver,
                    React.createElement("br", null),
                    vulnerability.resolved_fw_ver_date),
                React.createElement("td", null,
                    vulnerability.latest_fw_ver,
                    React.createElement("br", null),
                    vulnerability.latest_fw_ver_date),
                React.createElement("td", null, vulnerability.country_cd),
                React.createElement("td", null, vulnerability.geo_region_cd),
                React.createElement("td", null, vulnerability.city),
                React.createElement("td", null, vulnerability.state_province),
                React.createElement("td", null,
                    React.createElement("a", { href: vulnerability.security_doc_url }, vulnerability.security_doc)),
                React.createElement("td", null, vulnerability.cvss_base_score)));
        });
        return (React.createElement("table", { key: "VulnerabilitiesTable", className: "table" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, localeStrings['Status']),
                    React.createElement("th", null, localeStrings['Device_ID']),
                    React.createElement("th", null, localeStrings['Product']),
                    React.createElement("th", null, localeStrings['Device_FW_Ver']),
                    React.createElement("th", null, localeStrings['Resolved_FW_Ver']),
                    React.createElement("th", null, localeStrings['Latest_FW_Ver']),
                    React.createElement("th", null, localeStrings['CNTRY']),
                    React.createElement("th", null, localeStrings['REGION']),
                    React.createElement("th", null, localeStrings['CITY']),
                    React.createElement("th", null, localeStrings['STATE']),
                    React.createElement("th", null, localeStrings['Security_Bulletin']),
                    React.createElement("th", null,
                        "CVSS",
                        React.createElement("a", { href: "javascript:void(0)", onClick: this.handleShow },
                            React.createElement(react_bootstrap_1.Glyphicon, { glyph: "glyphicon glyphicon-question-sign" })),
                        React.createElement(react_bootstrap_1.Modal, { show: this.state.show, onHide: this.handleClose },
                            React.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
                                React.createElement(react_bootstrap_1.Modal.Title, null,
                                    "CVSS ",
                                    localeStrings['Help'])),
                            React.createElement(react_bootstrap_1.Modal.Body, null,
                                React.createElement("img", { src: localeStrings['CSV_Image'], alt: "CVSS Help", width: "95%" })),
                            React.createElement(react_bootstrap_1.Modal.Footer, null,
                                React.createElement(react_bootstrap_1.Button, { onClick: this.handleClose }, localeStrings['Close'])))))),
            React.createElement("tbody", null, rows)));
    };
    return VulnerabilitiesTable;
}(React.Component));
var About = /** @class */ (function (_super) {
    __extends(About, _super);
    function About() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    About.prototype.render = function () {
        var rows = [];
        var aboutNames = [localeStrings['Database_build_date'], localeStrings['Firmware_du'], localeStrings['Program_du'], localeStrings['Program_alias_du'], localeStrings['Vulnerability_du'], localeStrings['Bulletin_du'], localeStrings['Device_du'], localeStrings['Customer_du']];
        var i = 0;
        this.props.aboutItems.forEach(function (aboutItem, i) {
            rows.push(React.createElement("tr", { key: aboutItem.display_priority },
                React.createElement("td", null, aboutNames[i]),
                React.createElement("td", null, aboutItem.value)));
            i++;
        });
        return (React.createElement("table", { className: "table" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, localeStrings['Name']),
                    React.createElement("th", null, localeStrings['Value']))),
            React.createElement("tbody", null, rows)));
    };
    return About;
}(React.Component));
var StatusFilter = /** @class */ (function (_super) {
    __extends(StatusFilter, _super);
    function StatusFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StatusFilter.prototype.render = function () {
        return (React.createElement("select", { onChange: this.handleChange.bind(this), value: this.props.selectedStatus },
            React.createElement("option", { value: "" }, localeStrings['All_Status']),
            React.createElement("option", { value: "Not evaluated" }, localeStrings['Not_evaluated_label']),
            React.createElement("option", { value: "Vulnerable" }, localeStrings['Vulnerable_label']),
            React.createElement("option", { value: "Out-of-support" }, localeStrings['reactive_support']),
            React.createElement("option", { value: "No Firmware" }, localeStrings['No_Firmware_label']),
            React.createElement("option", { value: "Out-of-date" }, localeStrings['Out_of_date_label']),
            React.createElement("option", { value: "No data" }, localeStrings['No_data_label']),
            React.createElement("option", { value: "OK" }, localeStrings['ok_label']),
            React.createElement("option", { value: "" }, localeStrings['Limited_Reporting'])));
    };
    StatusFilter.prototype.handleChange = function (e) {
        this.props.callback(e.target.value);
    };
    return StatusFilter;
}(React.Component));
var MinRevsOutOfDateFilter = /** @class */ (function (_super) {
    __extends(MinRevsOutOfDateFilter, _super);
    function MinRevsOutOfDateFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MinRevsOutOfDateFilter.prototype.render = function () {
        return (React.createElement("select", { onChange: this.handleChange.bind(this), value: this.props.selectedMinRevsOutOfDate.toString() },
            React.createElement("option", { value: "0" },
                "0 ",
                localeStrings['or_more_revs_out_of_date']),
            React.createElement("option", { value: "1" },
                "1 ",
                localeStrings['or_more_revs_out_of_date']),
            React.createElement("option", { value: "2" },
                "2 ",
                localeStrings['or_more_revs_out_of_date']),
            React.createElement("option", { value: "3" },
                "3 ",
                localeStrings['or_more_revs_out_of_date']),
            React.createElement("option", { value: "4" },
                "4 ",
                localeStrings['or_more_revs_out_of_date']),
            React.createElement("option", { value: "5" },
                "5 ",
                localeStrings['or_more_revs_out_of_date'])));
    };
    MinRevsOutOfDateFilter.prototype.handleChange = function (e) {
        this.props.callback(Number(e.target.value));
    };
    return MinRevsOutOfDateFilter;
}(React.Component));
var SecurityDocFilter = /** @class */ (function (_super) {
    __extends(SecurityDocFilter, _super);
    function SecurityDocFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SecurityDocFilter.prototype.render = function () {
        var securityDocs = this.getSecurityDocs();
        var options = [];
        securityDocs.forEach(function (securityDoc, i) {
            options.push(React.createElement("option", { key: i, value: securityDoc }, securityDoc));
        });
        return (React.createElement("select", { onChange: this.handleChange.bind(this), value: this.props.selectedSecurityDoc },
            React.createElement("option", { value: "" }, localeStrings['All_Security_Bulletins']),
            options));
    };
    SecurityDocFilter.prototype.getSecurityDocs = function () {
        var vulnerabilities = this.props.selectedCustomerVulnerabilities;
        var securityDocs = vulnerabilities.map(function (v) { return v.security_doc; });
        var uniqueSecurityDocs = securityDocs.filter(function (v, i, a) { return a.indexOf(v) === i; });
        return uniqueSecurityDocs;
    };
    SecurityDocFilter.prototype.handleChange = function (e) {
        this.props.callback(e.target.value);
    };
    return SecurityDocFilter;
}(React.Component));
var RegionFilter = /** @class */ (function (_super) {
    __extends(RegionFilter, _super);
    function RegionFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RegionFilter.prototype.render = function () {
        var regions = this.props.availableRegions;
        var options = [];
        regions.forEach(function (region, i) {
            options.push(React.createElement("option", { key: i, value: region }, region));
        });
        return (React.createElement("select", { onChange: this.handleChange.bind(this), value: this.props.selectedRegion },
            React.createElement("option", { value: "" }, localeStrings['summary_All_Regions']),
            options));
    };
    RegionFilter.prototype.handleChange = function (e) {
        this.props.callback(e.target.value);
    };
    return RegionFilter;
}(React.Component));
function stringCompare(s1, s2) {
    return (s1 < s2) ? -1 : (s1 > s2) ? 1 : 0;
}
var CountryFilter = /** @class */ (function (_super) {
    __extends(CountryFilter, _super);
    function CountryFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CountryFilter.prototype.render = function () {
        var countries = this.props.availableCountries.map(function (c) {
            return {
                code: c, name: prependCountryName(c)
            };
        }).filter(function (c) { return c.code != 'XX'; }).sort(function (s1, s2) { return stringCompare(s1.name.toUpperCase(), s2.name.toUpperCase()); });
        var options = [];
        countries.forEach(function (countryItem, i) {
            options.push(React.createElement("option", { key: i, value: countryItem.code }, prependCountryName(countryItem.name)));
        });
        return (React.createElement("select", { onChange: this.handleChange.bind(this), value: this.props.selectedCountry },
            React.createElement("option", { value: "" }, localeStrings['summary_All_Countries']),
            options));
    };
    CountryFilter.prototype.handleChange = function (e) {
        this.props.callback(e.target.value);
    };
    return CountryFilter;
}(React.Component));
var MinCvssBaseScoreFilter = /** @class */ (function (_super) {
    __extends(MinCvssBaseScoreFilter, _super);
    function MinCvssBaseScoreFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MinCvssBaseScoreFilter.prototype.render = function () {
        return (React.createElement("select", { onChange: this.handleChange.bind(this), value: this.props.selectedMinCvssBaseScore.toString() },
            React.createElement("option", { value: "0" },
                localeStrings['CVSS_Base_Score_of'],
                " 0 ",
                localeStrings['or_more']),
            React.createElement("option", { value: "1" },
                localeStrings['CVSS_Base_Score_of'],
                " 1 ",
                localeStrings['or_more']),
            React.createElement("option", { value: "2" },
                localeStrings['CVSS_Base_Score_of'],
                " 2 ",
                localeStrings['or_more']),
            React.createElement("option", { value: "3" },
                localeStrings['CVSS_Base_Score_of'],
                " 3 ",
                localeStrings['or_more']),
            React.createElement("option", { value: "4" },
                localeStrings['CVSS_Base_Score_of'],
                " 4 ",
                localeStrings['or_more']),
            React.createElement("option", { value: "5" },
                localeStrings['CVSS_Base_Score_of'],
                " 5 ",
                localeStrings['or_more']),
            React.createElement("option", { value: "6" },
                localeStrings['CVSS_Base_Score_of'],
                " 6 ",
                localeStrings['or_more']),
            React.createElement("option", { value: "7" },
                localeStrings['CVSS_Base_Score_of'],
                " 7 ",
                localeStrings['or_more']),
            React.createElement("option", { value: "8" },
                localeStrings['CVSS_Base_Score_of'],
                " 8 ",
                localeStrings['or_more']),
            React.createElement("option", { value: "9" },
                localeStrings['CVSS_Base_Score_of'],
                " 9 ",
                localeStrings['or_more'])));
    };
    MinCvssBaseScoreFilter.prototype.handleChange = function (e) {
        this.props.callback(Number(e.target.value));
    };
    return MinCvssBaseScoreFilter;
}(React.Component));
var CustomerViewTabs = /** @class */ (function (_super) {
    __extends(CustomerViewTabs, _super);
    function CustomerViewTabs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomerViewTabs.prototype.render = function () {
        var labels = [localeStrings['Summary'], localeStrings['Devices'], localeStrings['Bulletins']];
        if ($.inArray(this.props.selectedTab, labels) === -1)
            return null;
        return (React.createElement(react_bootstrap_1.Tabs, { activeKey: this.props.selectedTab, onSelect: this.handleSelect.bind(this), id: "CustomerViewTabs" }, labels.map(function (label, i) { return React.createElement(react_bootstrap_1.Tab, { eventKey: label, title: label, key: String(i) }); })));
    };
    CustomerViewTabs.prototype.handleSelect = function (eventKey) {
        this.props.callback(eventKey);
    };
    return CustomerViewTabs;
}(React.Component));
var ApplicationViewPills = /** @class */ (function (_super) {
    __extends(ApplicationViewPills, _super);
    function ApplicationViewPills() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ApplicationViewPills.prototype.render = function () {
        var labels = [localeStrings['customer'], localeStrings['Entire_Fleet'], localeStrings['About']];
        if ($.inArray(this.props.selectedPill, labels) === -1)
            return null;
        return (React.createElement(react_bootstrap_1.Nav, { bsStyle: "pills", stacked: true, activeKey: this.props.selectedPill, onSelect: this.handleSelect.bind(this), id: "ApplicationViewPills" }, labels.map(function (label, i) { return React.createElement(react_bootstrap_1.NavItem, { eventKey: label, title: label, key: String(i) }, label); })));
    };
    ApplicationViewPills.prototype.handleSelect = function (eventKey) {
        this.props.callback(eventKey);
    };
    return ApplicationViewPills;
}(React.Component));
function csvField(f) {
    var result;
    if (f === null)
        result = "";
    else if (f instanceof Date)
        result = f.toLocaleString();
    else
        result = f.toString();
    result = result.replace(/"/g, '""');
    if (result.search(/("|,|\n)/g) >= 0)
        result = '"' + result + '"';
    return result;
}
function convertJSONObjectToCSVRow(fields, jsonObject) {
    return fields.map(function (field) { return jsonObject.hasOwnProperty(field) ? csvField(jsonObject[field]) : ''; }).join(',');
}
function convertJSONObjectListToCSV(fields, jsonObjects) {
    return fields.map(function (field) { return csvField(field); }).join(',') + '\n'
        + jsonObjects.map(function (jsonObject) { return convertJSONObjectToCSVRow(fields, jsonObject); }).join('\n');
}
function save(filename, data) {
    var blob = new Blob([data], { type: 'text/csv' });
    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, filename);
    }
    else {
        var elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = filename;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
    }
}
var customersCache = [];
var CustomerPage = /** @class */ (function (_super) {
    __extends(CustomerPage, _super);
    function CustomerPage(props) {
        var _this = _super.call(this, props) || this;
        _this.filterVulnerabilities = function (vulnerabilities, selectedCountry, selectedRegion, selectedSecurityDoc, selectedMinCvssBaseScore) {
            return vulnerabilities.filter(function (v) { return (selectedSecurityDoc === "" || selectedSecurityDoc === v.security_doc)
                && (selectedCountry === "" || selectedCountry === v.country_cd)
                && (selectedRegion === "" || selectedRegion === v.geo_region_cd)
                && (selectedMinCvssBaseScore === null || Number(v.cvss_base_score) >= selectedMinCvssBaseScore); });
        };
        _this.filteredVulnerabilities = function () {
            return _this.filterVulnerabilities(_this.state.selectedCustomerVulnerabilities, _this.state.selectedCountry, _this.state.selectedRegion, _this.state.selectedSecurityDoc, _this.state.selectedMinCvssBaseScore);
        };
        _this.filterPrintersOnlyOnCountryAndRegion = function (printers, selectedCountry, selectedRegion) {
            return printers.filter(function (p) { return (selectedCountry === "" || selectedCountry === p.country_cd)
                && (selectedRegion === "" || selectedRegion === p.geo_region_cd); });
        };
        _this.filterPrinters = function (printers, selectedCountry, selectedRegion, status, min_revs_out_of_date) {
            return _this.filterPrintersOnlyOnCountryAndRegion(printers, selectedCountry, selectedRegion).filter(function (p) { return (p.status != "NonHP")
                && (status === "" || status === removeParentheticalComment(p.status))
                && (min_revs_out_of_date === null || Number(p.revs_out_of_date) >= min_revs_out_of_date); });
        };
        _this.filteredPrinters = function () {
            return _this.filterPrinters(_this.state.selectedCustomerPrinters, _this.state.selectedCountry, _this.state.selectedRegion, _this.state.selectedStatus, _this.state.selectedMinRevsOutOfDate);
        };
        _this.filteredPrintersOnlyOnCountryAndRegion = function () {
            return _this.filterPrintersOnlyOnCountryAndRegion(_this.state.selectedCustomerPrinters, _this.state.selectedCountry, _this.state.selectedRegion);
        };
        _this.availableRegions = function () {
            if (_this.state.selectedTab === 'By Region') {
                return ['AMS', 'APJ', 'EMEA'];
            }
            else {
                var printers = _this.state.selectedCustomerPrinters;
                var regions = printers.map(function (p) { return p.geo_region_cd; });
                var uniqueRegions = regions.filter(function (v, i, a) { return a.indexOf(v) === i; });
                return uniqueRegions;
            }
        };
        _this.availableCountries = function () {
            var printers = _this.state.selectedCustomerPrinters;
            var region = _this.state.selectedRegion;
            var countries = printers.filter(function (p) { return region === "" || region === p.geo_region_cd; }).map(function (p) { return p.country_cd; });
            var uniqueCountries = countries.filter(function (v, i, a) { return a.indexOf(v) === i; });
            return uniqueCountries;
        };
        console.log("CustomerPage: constructor");
        _this.state = {
            customers: [],
            selectedCustomer: "",
            selectedStatus: "",
            selectedMinRevsOutOfDate: 0,
            selectedMinCvssBaseScore: 0,
            selectedSecurityDoc: "",
            selectedCountry: "",
            selectedRegion: "",
            selectedTab: "",
            selectedCustomerPrinters: [],
            selectedCustomerVulnerabilities: [],
            loadingMessage: null,
            errorMessage: null,
        };
        _this.serverRequest = null;
        return _this;
    }
    CustomerPage.prototype.setError = function (message) {
        this.setState({
            errorMessage: message,
            selectedTab: "Error",
            loadingMessage: null
        });
    };
    CustomerPage.prototype.handleUploadFleetData = function (e) {
        var file = this.refs.file.files[0];
        var reader = new FileReader();
        this.setState({
            loadingMessage: localeStrings['loading_message'] + "'" + file.name + "'",
            selectedTab: ""
        });
        reader.onload = function (output) {
            // console.log(output.target.result); 
            var _this = this;
            $.post("/api/printersAndVulnerabilities", { a: "AAA", b: "BBB", fileData: output.target.result })
                .done(function (results) {
                var resultsObj = JSON.parse(results);
                if (resultsObj.hasOwnProperty('printers') && resultsObj.hasOwnProperty('vulnerabilities')) {
                    _this.setState({
                        selectedCustomer: file.name,
                        selectedCustomerPrinters: resultsObj.printers,
                        selectedCustomerVulnerabilities: resultsObj.vulnerabilities,
                        selectedTab: localeStrings['Summary'],
                        loadingMessage: null,
                        // clear filters
                        selectedMinRevsOutOfDate: 0,
                        selectedSecurityDoc: "",
                        selectedCountry: "",
                        selectedRegion: "",
                    });
                    _this.refs.file.value = "";
                    _this.refs.customerSearcher.changeValue(file.name);
                }
                else if (resultsObj.hasOwnProperty('invalidCsvFile')) {
                    _this.refs.file.value = "";
                    _this.refs.customerSearcher.changeValue(file.name);
                    _this.setError(localeStrings['Error_msg_1']
                        + localeStrings['Error_msg_2']
                        + localeStrings['Error_msg_3']
                        + localeStrings['Error_msg_4']
                        + localeStrings['Error_msg_5']).bind(_this);
                }
                else {
                    throw "handleUploadFleetData: unexpected return value from server";
                }
            })
                .fail(console.log.bind(console));
        }.bind(this);
        reader.readAsText(file);
        e.preventDefault();
    };
    CustomerPage.prototype.handleSimulatedUploadButtonClick = function () {
        this.refs.file.click();
    };
    CustomerPage.prototype.render = function () {
        console.log("CustomerPage: render");
        var uploadCustomerDataHelpStyle = {
            maxWidth: "600px",
            width: "auto"
        };
        var uploadCustomerDataHelp = (React.createElement(react_bootstrap_1.Popover, { style: uploadCustomerDataHelpStyle, id: "popover-positioned-bottom", title: localeStrings['upload_customer_device_list'] },
            localeStrings['Device_list_help'],
            React.createElement("ul", null,
                React.createElement("br", null),
                React.createElement("li", null, localeStrings['Device_help_display_Name']),
                React.createElement("li", null, localeStrings['Device_help_device_firmware']),
                React.createElement("li", null, localeStrings['Device_help_serial_number']),
                React.createElement("li", null, localeStrings['Device_help_device_type']),
                React.createElement("li", null, localeStrings['Device_help_product']),
                React.createElement("li", null, localeStrings['Device_help_geo_region']),
                React.createElement("li", null, localeStrings['Device_help_country_cd']))));
        var questionMarkIconStyle = {
            paddingLeft: "10px",
            cursor: "pointer"
        };
        return (React.createElement("div", null,
            React.createElement("div", { className: "col-xs-9 text-left" },
                React.createElement("div", { className: "form-group" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-xs-6" },
                            React.createElement(CustomerSearcher, { ref: "customerSearcher", customers: this.state.customers, selectedCustomer: this.state.selectedCustomer, callback: this.handleCustomerSelectionChange.bind(this) })),
                        React.createElement("div", { className: "col-xs-6" },
                            React.createElement("form", { ref: "uploadForm", className: "uploader", encType: "multipart/form-data" },
                                React.createElement("input", { ref: "file", type: "file", accept: ".csv", style: { display: 'none' }, onChange: this.handleUploadFleetData.bind(this) }),
                                React.createElement("input", { type: "button", value: localeStrings['upload_customer_help_button'], onClick: this.handleSimulatedUploadButtonClick.bind(this) }),
                                React.createElement(react_bootstrap_1.OverlayTrigger, { trigger: "click", placement: "bottom", overlay: uploadCustomerDataHelp },
                                    React.createElement(react_bootstrap_1.Glyphicon, { style: questionMarkIconStyle, glyph: "glyphicon glyphicon-question-sign" })))))),
                React.createElement("div", null,
                    React.createElement(CustomerViewTabs, { selectedTab: this.state.selectedTab, callback: this.handleCustomerViewTabsChange.bind(this) }))),
            React.createElement("div", { className: "col-xs-9 text-left" }, this.renderContent()),
            React.createElement("div", { className: "col-xs-2 sidenav" }, this.renderOperations())));
    };
    CustomerPage.prototype.renderContent = function () {
        if (this.state.loadingMessage) {
            return (React.createElement(react_bootstrap_1.Well, null,
                React.createElement("h1", null, this.state.loadingMessage),
                React.createElement(react_bootstrap_1.ProgressBar, { active: true, now: 100 })));
        }
        var content = null;
        switch (this.state.selectedTab) {
            case localeStrings['Summary']:
                content =
                    React.createElement("div", { id: "summary-content", className: "tab-pane fade in" },
                        React.createElement("br", null),
                        React.createElement("br", null),
                        React.createElement(SummaryTable, { filteredOnlyOnCountryAndRegionPrinters: this.filteredPrintersOnlyOnCountryAndRegion() }));
                break;
            case localeStrings['Devices']:
                content =
                    React.createElement("div", { id: "devices-content", className: "tab-pane fade in" },
                        React.createElement("br", null),
                        React.createElement("br", null),
                        React.createElement(PrintersTable, { filteredPrinters: this.filteredPrinters() }));
                break;
            case localeStrings['Bulletins']:
                content =
                    React.createElement("div", { id: "vulnerabilities-content", className: "tab-pane fade in" },
                        React.createElement("br", null),
                        React.createElement("br", null),
                        React.createElement(VulnerabilitiesTable, { filteredVulnerabilities: this.filteredVulnerabilities() }));
                break;
            case "Error":
                content =
                    React.createElement("div", { id: "error-content", className: "tab-pane fade in" },
                        React.createElement("br", null),
                        React.createElement("h1", null, localeStrings['An_Error_Has_Occurred']),
                        this.state.errorMessage,
                        React.createElement("div", { className: "Note" },
                            React.createElement("p", null,
                                " ",
                                React.createElement("b", null,
                                    " ",
                                    localeStrings['Error_msg_6'],
                                    " ",
                                    React.createElement("a", { href: localeStrings['Instruction_To_Upload_CSV'], target: "_blank" }, localeStrings['customer_click_here']),
                                    ".",
                                    React.createElement("br", null),
                                    localeStrings['Error_msg_7'],
                                    "\u00A0",
                                    React.createElement("a", { href: "mailto:Invalid_CSV_File_Review@external.groups.hp.com?Subject=Firmware%20Security%20Tool%20-%20Invalid%20CSV%20File(s)&body=Name%20of%20the%20tool%20used%20to%20generate%20CSV:%0D%0ANote:%20Please%20make%20sure%20to%20attach%20CSV%20file%20before%20sending%20this%20email", target: "_top" }, localeStrings['Error_msg_8']),
                                    " "))));
                break;
            default:
                content =
                    React.createElement("div", { id: "home-content", className: "tab-pane fade in active" },
                        localeStrings['customer_intro'],
                        React.createElement("br", null),
                        React.createElement("b", null, localeStrings['customer_warning']),
                        " ",
                        localeStrings['customer_warning_content'],
                        " ",
                        React.createElement("a", { href: localeStrings['Instruction_To_Upload_CSV'], target: "_blank" }, localeStrings['customer_click_here']),
                        ".");
                break;
        }
        return content;
    };
    CustomerPage.prototype.renderOperations = function () {
        var operations = null;
        switch (this.state.selectedTab) {
            case localeStrings['Devices']:
                operations = React.createElement("div", { id: "devices-operations", className: "tab-pane fade in" },
                    React.createElement("button", { id: "export_devices", className: "btn btn-primary", onClick: this.handleDevicesExportClick.bind(this) }, localeStrings['Export']),
                    React.createElement("hr", null),
                    React.createElement("strong", null, localeStrings['Status']),
                    React.createElement("br", null),
                    React.createElement(StatusFilter, { selectedCustomerPrinters: this.state.selectedCustomerPrinters, selectedStatus: this.state.selectedStatus, callback: this.handleStatusFilterChange.bind(this) }),
                    React.createElement("hr", null),
                    React.createElement("strong", null, localeStrings['Min_Revs_Out_of_Date']),
                    React.createElement("br", null),
                    React.createElement(MinRevsOutOfDateFilter, { selectedCustomerPrinters: this.state.selectedCustomerPrinters, selectedMinRevsOutOfDate: this.state.selectedMinRevsOutOfDate, callback: this.handleMinRevsOutOfDateFilterChange.bind(this) }),
                    React.createElement("hr", null),
                    React.createElement("strong", null, localeStrings['Region']),
                    React.createElement("br", null),
                    React.createElement(RegionFilter, { availableRegions: this.availableRegions(), selectedRegion: this.state.selectedRegion, callback: this.handleRegionFilterChange.bind(this) }),
                    React.createElement("hr", null),
                    React.createElement("strong", null, localeStrings['Country']),
                    React.createElement("br", null),
                    React.createElement(CountryFilter, { availableCountries: this.availableCountries(), selectedRegion: this.state.selectedRegion, selectedCountry: this.state.selectedCountry, callback: this.handleCountryFilterChange.bind(this) }));
                break;
            case localeStrings['Bulletins']:
                operations =
                    React.createElement("div", { id: "vulnerabilities-operations", className: "tab-pane fade in" },
                        React.createElement("button", { id: "export_vulnerabilities", className: "btn btn-primary", onClick: this.handleVulnerabilitiesExportClick.bind(this) }, localeStrings['Export']),
                        React.createElement("hr", null),
                        React.createElement("strong", null, localeStrings['Security_Document']),
                        React.createElement("br", null),
                        React.createElement(SecurityDocFilter, { selectedCustomerVulnerabilities: this.state.selectedCustomerVulnerabilities, selectedSecurityDoc: this.state.selectedSecurityDoc, callback: this.handleSecurityDocFilterChange.bind(this) }),
                        React.createElement("hr", null),
                        React.createElement("strong", null, localeStrings['CVSS_Base_Score']),
                        React.createElement("br", null),
                        React.createElement(MinCvssBaseScoreFilter, { selectedMinCvssBaseScore: this.state.selectedMinCvssBaseScore, callback: this.handleMinCvssBaseScoreChange.bind(this) }),
                        React.createElement("br", null),
                        "(0=",
                        localeStrings['low'],
                        "; 9=",
                        localeStrings['high'],
                        ")",
                        React.createElement("hr", null),
                        React.createElement("strong", null, localeStrings['Region']),
                        React.createElement("br", null),
                        React.createElement(RegionFilter, { availableRegions: this.availableRegions(), selectedRegion: this.state.selectedRegion, callback: this.handleRegionFilterChange.bind(this) }),
                        React.createElement("hr", null),
                        React.createElement("strong", null, localeStrings['Country']),
                        React.createElement("br", null),
                        React.createElement(CountryFilter, { availableCountries: this.availableCountries(), selectedRegion: this.state.selectedRegion, selectedCountry: this.state.selectedCountry, callback: this.handleCountryFilterChange.bind(this) }));
                break;
            case localeStrings['Summary']:
                operations =
                    React.createElement("div", { id: "summary-operations", className: "tab-pane fade in" },
                        React.createElement("strong", null, localeStrings['Region']),
                        React.createElement("br", null),
                        React.createElement(RegionFilter, { availableRegions: this.availableRegions(), selectedRegion: this.state.selectedRegion, callback: this.handleRegionFilterChange.bind(this) }),
                        React.createElement("hr", null),
                        React.createElement("strong", null, localeStrings['Country']),
                        React.createElement("br", null),
                        React.createElement(CountryFilter, { availableCountries: this.availableCountries(), selectedRegion: this.state.selectedRegion, selectedCountry: this.state.selectedCountry, callback: this.handleCountryFilterChange.bind(this) }));
                break;
        }
        return operations;
    };
    CustomerPage.prototype.componentDidMount = function () {
        var _this = this;
        console.log("CustomerPage: componentDidMount");
        this.setState({
            loadingMessage: localeStrings['Loading_customer_List']
        });
        if (customersCache.length == 0) {
            console.log("CustomerPage: componentDidMount: fetching customers");
            this.serverRequest = $.getJSON("/api/customer")
                .done(function (results) {
                customersCache = results;
                _this.setState({ customers: customersCache, loadingMessage: null });
            })
                .fail(console.log.bind(console));
        }
        else {
            console.log("CustomerPage: componentDidMount: using cached customers");
            this.setState({ customers: customersCache, loadingMessage: null });
        }
    };
    CustomerPage.prototype.componentWillUnmount = function () {
        console.log("CustomerPage: componentWillUnmount");
        if (this.serverRequest)
            this.serverRequest.abort();
    };
    CustomerPage.prototype.handleCustomerSelectionChange = function (customer) {
        var _this = this;
        this.setState({
            loadingMessage: localeStrings['loading_message'] + "'" + customer + "'",
            selectedTab: ""
        });
        $.getJSON("/api/customer/Printers/" + customer)
            .done(function (results) {
            _this.setState({
                selectedCustomer: customer,
                selectedCustomerPrinters: results,
                selectedTab: localeStrings['Summary'],
                loadingMessage: null,
                // clear filters
                selectedMinRevsOutOfDate: 0,
                selectedSecurityDoc: "",
                selectedCountry: "",
                selectedRegion: "",
            });
        })
            .fail(console.log.bind(console));
        // Pre-load vulnerabilities as well
        $.getJSON("/api/customer/vulnerabilities/" + customer)
            .done(function (results) {
            _this.setState({
                selectedCustomer: customer,
                selectedCustomerVulnerabilities: results,
            });
        })
            .fail(console.log.bind(console));
    };
    CustomerPage.prototype.handleStatusFilterChange = function (selectedState) {
        this.setState({
            selectedStatus: selectedState
        });
    };
    CustomerPage.prototype.handleMinRevsOutOfDateFilterChange = function (selectedMinRevsOutOfDate) {
        this.setState({
            selectedMinRevsOutOfDate: selectedMinRevsOutOfDate
        });
    };
    CustomerPage.prototype.handleMinCvssBaseScoreChange = function (selectedMinCvssBaseScore) {
        this.setState({
            selectedMinCvssBaseScore: selectedMinCvssBaseScore
        });
    };
    CustomerPage.prototype.handleSecurityDocFilterChange = function (selectedSecurityDoc) {
        this.setState({
            selectedSecurityDoc: selectedSecurityDoc
        });
    };
    CustomerPage.prototype.handleRegionFilterChange = function (selectedRegion) {
        this.setState({
            selectedRegion: selectedRegion,
            selectedCountry: ""
        });
    };
    CustomerPage.prototype.handleCountryFilterChange = function (selectedCountry) {
        this.setState({
            selectedCountry: selectedCountry,
            selectedRegion: ""
        });
    };
    CustomerPage.prototype.handleCustomerViewTabsChange = function (selectedTab) {
        this.setState({
            selectedTab: selectedTab
        });
    };
    CustomerPage.prototype.handleDevicesExportClick = function () {
        var filteredDevices = this.filteredPrinters();
        var fields = [
            "status",
            "serial_number",
            "ip_address",
            "prod_num",
            "prod_model",
            "dev_fw_ver",
            "dev_fw_ver_date",
            "latest_fw_ver",
            "latest_fw_ver_date",
            "revs_out_of_date",
            "vulnerability_count",
            "out_of_support",
            "geo_region_cd",
            "country_cd",
            "city",
            "state_province",
            "collect_method_desc",
            "device_status_desc",
            "last_collection_dt"
        ];
        filteredDevices.map(function (a) { return (a.status == "Ricoh" || a.status == "Xerox" || a.status == "Dell" || a.status == "OKI" || a.status == "Kyocera" ||
            a.status == "Konica" || a.status == "TallyGenicom" || a.status == "Toshiba" || a.status == "Canon" || a.status == "Lexmark" || a.status == "Zebra" || a.status == "Printronix" ||
            a.status == "Oce" || a.status == "Centronics" || a.status == "Brother" || a.status == "Brady" || a.status == "Okidata" || a.status == "Axis" || a.status == "Epson" ||
            a.status == "IBM" || a.status == "Fujitsu" || a.status == "Savin" || a.status == "Intermec" || a.status == "Dymo" || a.status == "Datamax" || a.status == "LabelTac" ||
            a.status == "PSI" || a.status == "Panasonic" || a.status == "Sharp" || a.status == "Muratec" || a.status == "Komdruck" || a.status == "Kodak" || a.status == "ilwoo" ||
            a.status == "Utax" || a.status == "Troy" || a.status == "TallyGenicom_Printronix" || a.status == "Source" || a.status == "Microplex" || a.status == "Sewon" || a.status == "Sato") ? (a.latest_fw_ver = "NA") && (a.revs_out_of_date = "0") : a.latest_fw_ver; });
        var csv = convertJSONObjectListToCSV(fields, filteredDevices);
        var csv1 = csv.replace(/Samsung,/g, "Limited Reporting,").replace(/Ricoh,/g, "Limited Reporting,").replace(/Xerox,/g, "Limited Reporting,")
            .replace(/Dell,/g, "Limited Reporting,").replace(/OKI,/g, "Limited Reporting,").replace(/Kyocera,/g, "Limited Reporting,")
            .replace(/Konica,/g, "Limited Reporting,").replace(/TallyGenicom,/g, "Limited Reporting,").replace(/Toshiba,/g, "Limited Reporting,")
            .replace(/Canon,/g, "Limited Reporting,").replace(/Brother,/g, "Limited Reporting,").replace(/Brady,/g, "Limited Reporting,")
            .replace(/Oce,/g, "Limited Reporting,").replace(/Lexmark,/g, "Limited Reporting,").replace(/Zebra,/g, "Limited Reporting,")
            .replace(/IBM,/g, "Limited Reporting,").replace(/Printronix,/g, "Limited Reporting,").replace(/Okidata,/g, "Limited Reporting,")
            .replace(/PSI,/g, "Limited Reporting,").replace(/Axis,/g, "Limited Reporting,").replace(/Epson,/g, "Limited Reporting,")
            .replace(/Utax,/g, "Limited Reporting,").replace(/Datamax,/g, "Limited Reporting,").replace(/Intermec,/g, "Limited Reporting,")
            .replace(/Centronics,/g, "Limited Reporting,").replace(/Savin,/g, "Limited Reporting,").replace(/Dymo,/g, "Limited Reporting,")
            .replace(/Fujitsu,/g, "Limited Reporting,").replace(/LabelTac,/g, "Limited Reporting,").replace(/Sharp,/g, "Limited Reporting,")
            .replace(/Panasonic,/g, "Limited Reporting,").replace(/Komdruck,/g, "Limited Reporting,").replace(/Muratec,/g, "Limited Reporting,")
            .replace(/Troy,/g, "Limited Reporting,").replace(/TallyGenicom_Printronix,/g, "Limited Reporting,").replace(/Sewon,/g, "Limited Reporting,")
            .replace(/Source,/g, "Limited Reporting,").replace(/Microplex,/g, "Limited Reporting,").replace(/Sato,/g, "Limited Reporting,")
            .replace(/Kodak,/g, "Limited Reporting,").replace(/ilwoo,/g, "Limited Reporting,").replace('status', localeStrings['status'])
            .replace('serial_number', localeStrings['serial_number']).replace('ip_address', localeStrings['ip_address']).replace('prod_num', localeStrings['prod_num'])
            .replace('prod_model', localeStrings['prod_model']).replace('dev_fw_ver', localeStrings['dev_fw_ver']).replace('dev_fw_ver_date', localeStrings['dev_fw_ver_date'])
            .replace('latest_fw_ver', localeStrings['latest_fw_ver']).replace('latest_fw_ver_date', localeStrings['latest_fw_ver_date']).replace('revs_out_of_date', localeStrings['revs_out_of_date'])
            .replace('geo_region_cd', localeStrings['geo_region_cd']).replace('out_of_support', localeStrings['out_of_support']).replace('vulnerability_count', localeStrings['vulnerability_count'])
            .replace('state_province', localeStrings['state_province']).replace('city', localeStrings['city']).replace('country_cd', localeStrings['country_cd'])
            .replace('device_status_desc', localeStrings['device_status_desc']).replace('collect_method_desc', localeStrings['collect_method_desc']).replace('last_collection_dt', localeStrings['last_collection_dt']);
        save("devices.csv", csv1);
    };
    CustomerPage.prototype.handleVulnerabilitiesExportClick = function () {
        var filteredVulnerabilities = this.filteredVulnerabilities();
        var fields = [
            "status",
            "serial_number",
            "ip_address",
            "prod_num",
            "prod_model",
            "dev_fw_ver",
            "dev_fw_ver_date",
            "resolved_fw_ver",
            "resolved_fw_ver_date",
            "latest_fw_ver",
            "latest_fw_ver_date",
            "security_doc_url",
            "security_doc",
            "geo_region_cd",
            "country_cd",
            "city",
            "state_province",
            "cvss_base_score"
        ];
        var csv = convertJSONObjectListToCSV(fields, filteredVulnerabilities);
        var updatedCsv = csv.replace("status,", localeStrings['Status'] + ",").replace("serial_number,", localeStrings['serial_number'] + ",").replace("ip_address,", localeStrings['ip_address'] + ",")
            .replace("prod_num,", localeStrings['prod_num'] + ",").replace("prod_model,", localeStrings['prod_model'] + ",").replace("dev_fw_ver,", localeStrings['dev_fw_ver'] + ",")
            .replace("dev_fw_ver_date,", localeStrings['dev_fw_ver_date'] + ",").replace("latest_fw_ver,", localeStrings['latest_fw_ver'] + ",").replace("latest_fw_ver_date,", localeStrings['latest_fw_ver_date'] + ",")
            .replace("resolved_fw_ver,", localeStrings['resolved_fw_ver'] + ",").replace("resolved_fw_ver_date,", localeStrings['resolved_fw_ver_date'] + ",").replace("security_doc_url,", localeStrings['security_doc_url'] + ",")
            .replace(",geo_region_cd,", localeStrings['geo_region_cd'] + ",").replace(",country_cd,", localeStrings['country_cd'] + ",").replace(",city,", localeStrings['city'] + ",")
            .replace("state_province,", localeStrings['state_province'] + ",").replace("security_doc,", localeStrings['security_doc'] + ",").replace("cvss_base_score,", localeStrings['cvss_base_score'] + ",");
        save("vulnerabilities.csv", csv);
    };
    return CustomerPage;
}(React.Component));
var regionStatusCountsCache = [];
var WorldWidePage = /** @class */ (function (_super) {
    __extends(WorldWidePage, _super);
    function WorldWidePage(props) {
        var _this = _super.call(this, props) || this;
        _this.filteredRegionStatusCounts = function () {
            var selectedRegion = _this.state.selectedRegion;
            var selectedCountry = _this.state.selectedCountry;
            var filteredRegionStatusCounts = _this.state.regionStatusCounts.filter(function (rsc) { return ((selectedRegion === "" || selectedRegion === rsc.geo_region_cd)
                && (selectedCountry === "" || selectedCountry === rsc.country_cd)); });
            return filteredRegionStatusCounts;
        };
        _this.availableCountries = function () {
            var regionStatusCounts = _this.state.regionStatusCounts;
            var region = _this.state.selectedRegion;
            var countries = regionStatusCounts.filter(function (rsc) { return region === "" || region === rsc.geo_region_cd; }).map(function (rsc) { return rsc.country_cd; });
            var uniqueCountries = countries.filter(function (v, i, a) { return a.indexOf(v) === i; });
            return uniqueCountries;
        };
        _this.handleRegionFilterChange = function (selectedRegion) {
            _this.setState({
                selectedRegion: selectedRegion,
                selectedCountry: ""
            });
        };
        _this.handleCountryFilterChange = function (selectedCountry) {
            _this.setState({
                selectedCountry: selectedCountry
            });
        };
        _this.availableRegions = function () {
            return ['AMS', 'APJ', 'EMEA'];
        };
        console.log("WorldWidePage: constructor");
        _this.state = {
            regionStatusCounts: [],
            selectedRegion: "",
            selectedCountry: ""
        };
        _this.serverRequest = null;
        return _this;
    }
    WorldWidePage.prototype.render = function () {
        console.log("WorldWidePage: render");
        return (React.createElement("div", null,
            React.createElement("div", { className: "col-xs-9 text-left" },
                React.createElement("h3", null, localeStrings['Entire_Fleet']),
                React.createElement("br", null)),
            React.createElement("div", { className: "col-xs-9 text-left" },
                React.createElement(WorldWideSummaryTable, { regionStatusCounts: this.filteredRegionStatusCounts() })),
            React.createElement("div", { className: "col-xs-2 sidenav" },
                React.createElement("strong", null, localeStrings['summary_region']),
                React.createElement("br", null),
                React.createElement(RegionFilter, { availableRegions: this.availableRegions(), selectedRegion: this.state.selectedRegion, callback: this.handleRegionFilterChange.bind(this) }),
                React.createElement("hr", null),
                React.createElement("strong", null, localeStrings['summary_country']),
                React.createElement("br", null),
                React.createElement(CountryFilter, { availableCountries: this.availableCountries(), selectedRegion: this.state.selectedRegion, selectedCountry: this.state.selectedCountry, callback: this.handleCountryFilterChange.bind(this) }))));
    };
    WorldWidePage.prototype.componentDidMount = function () {
        var _this = this;
        console.log("WorldWidePage: componentDidMount");
        if (regionStatusCountsCache.length == 0) {
            console.log("WorldWidePage: componentDidMount: fetching region status count items");
            this.serverRequest = $.getJSON("/api/status_by_region")
                .done(function (results) {
                regionStatusCountsCache = results;
                _this.setState({ regionStatusCounts: regionStatusCountsCache });
            })
                .fail(console.log.bind(console));
        }
        else {
            console.log("WorldWidePage: componentDidMount: using cached region status count items");
            this.setState({ regionStatusCounts: regionStatusCountsCache });
        }
    };
    WorldWidePage.prototype.componentWillUnmount = function () {
        console.log("WorldWidePage: componentWillUnmount");
        if (this.serverRequest)
            this.serverRequest.abort();
    };
    return WorldWidePage;
}(React.Component));
var aboutItemsCache = [];
var AboutPage = /** @class */ (function (_super) {
    __extends(AboutPage, _super);
    function AboutPage(props) {
        var _this = this;
        console.log("AboutPage: constructor");
        _this = _super.call(this, props) || this;
        _this.state = {
            aboutItems: []
        };
        _this.serverRequest = null;
        return _this;
    }
    AboutPage.prototype.render = function () {
        console.log("AboutPage: render");
        console.log(this.state.aboutItems);
        return (React.createElement("div", null,
            React.createElement("div", { className: "col-xs-9 text-left" },
                React.createElement("h3", null, localeStrings['About']),
                React.createElement("br", null),
                React.createElement("div", { id: "about-content", className: "tab-pane fade in" },
                    React.createElement(About, { aboutItems: this.state.aboutItems }),
                    React.createElement("div", null,
                        localeStrings['contact'],
                        "\u00A0",
                        React.createElement("a", { href: "mailto:Curation_Questions@external.groups.hp.com?Subject=Firmware%20Security%20Tool%20Data%20Curation%20Question", target: "_top" }, "Curation_Questions@external.groups.hp.com"))))));
    };
    AboutPage.prototype.componentDidMount = function () {
        var _this = this;
        console.log("AboutPage: componentDidMount");
        if (aboutItemsCache.length == 0) {
            console.log("AboutPage: componentDidMount: fetching about items");
            this.serverRequest = $.getJSON("/api/about")
                .done(function (results) {
                aboutItemsCache = results;
                _this.setState({ aboutItems: aboutItemsCache });
            })
                .fail(console.log.bind(console));
        }
        else {
            console.log("AboutPage: componentDidMount: using cached about items");
            this.setState({ aboutItems: aboutItemsCache });
        }
    };
    AboutPage.prototype.componentWillUnmount = function () {
        console.log("AboutPage: componentWillUnmount");
        if (this.serverRequest)
            this.serverRequest.abort();
    };
    return AboutPage;
}(React.Component));
var Application = /** @class */ (function (_super) {
    __extends(Application, _super);
    function Application(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selectedRegion: "",
            selectedPill: "",
            aboutItems: [],
            regionStatusCounts: [],
            loadingMessage: null,
            justUpdate: ""
        };
        return _this;
    }
    Application.prototype.componentDidMount = function () {
        var _this = this;
        $.getJSON("/api/LocaleStrings")
            .done(function (results) {
            var JsonString = JSON.parse(results);
            localeStrings = new react_localization_1.default(JsonString);
            flag = false;
            categories = {
                'OK': { 'label': localeStrings['ok_label'], 'desc': localeStrings['ok_description'], 'style': 'printer-status-ok' },
                'Out-of-date': { 'label': localeStrings['Out_of_date_label'], 'desc': localeStrings['Out_of_date_desc'], 'style': 'printer-status-out-of-date' },
                'Out-of-support': { 'label': localeStrings['reactive_support'], 'desc': localeStrings['FW_has_no_known_security_bulletins_only_FW_fixes_addressing_prioritized_security_risks'], 'style': 'printer-status-out-of-support' },
                'Vulnerable': { 'label': localeStrings['Vulnerable_label'], 'desc': localeStrings['Vulnerable_desc'], 'style': 'printer-status-vulnerable' },
                'No Firmware': { 'label': localeStrings['No_Firmware_label'], 'desc': localeStrings['No_Firmware_desc'], 'style': 'printer-status-no-firmware' },
                'No data': { 'label': localeStrings['No_data_label'], 'desc': localeStrings['No_data_desc'], 'style': 'printer-status-no-data' },
                'Not evaluated': { 'label': localeStrings['Not_evaluated_label'], 'desc': localeStrings['Not_evaluated_desc'], 'style': 'printer-status-not-evaluated' }
            };
            _this.setState({ selectedPill: localeStrings['customer'] });
        })
            .fail(console.log.bind(console));
    };
    Application.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: "container-fluid text-center" },
                React.createElement("div", { className: "row content" },
                    React.createElement("div", { className: "col-xs-1 sidenav" },
                        React.createElement("img", { style: { "width": "60%" }, src: "wwwroot/images/hp_logo.png", alt: "HP MPS Logo" }),
                        React.createElement("div", { className: "" },
                            React.createElement("h5", null, localeStrings['HP_Managed_Print_Services'])),
                        React.createElement("hr", null),
                        this.state.selectedPill !== null ? React.createElement(ApplicationViewPills, { selectedPill: this.state.selectedPill, callback: this.handleApplicationViewTabsChange.bind(this) }) : ''),
                    React.createElement("div", { className: "col-xs-9 text-left" },
                        React.createElement("div", { className: "page-header" },
                            React.createElement("h1", null, localeStrings['HP_Firmware_Security']))),
                    React.createElement("div", null, this.renderPage()),
                    React.createElement("div", { className: "upgrade-future-smart-div" },
                        React.createElement("div", { className: "upgrade-future-smart-product" },
                            React.createElement("a", { href: localeStrings['Upgrading_FutureSmart_Products_doc_path'], target: "_blank" }, localeStrings['Upgrading_FutureSmart_Products']))))),
            React.createElement("footer", { className: "container-fluid text-center" },
                React.createElement("p", null,
                    localeStrings['version'],
                    " 1.1.0 RC1 [2019-10-16]"))));
    };
    Application.prototype.renderPage = function () {
        if (flag) {
            $.getJSON("/api/LocaleStrings")
                .done(function (results) {
                var JsonString = JSON.parse(results);
                localeStringsCustomer = new react_localization_1.default(JsonString);
            }).fail(console.log.bind(console));
        }
        switch (this.state.selectedPill) { // sssss
            case localeStringsCustomer['customer']: return React.createElement(CustomerPage, null);
            case localeStringsCustomer['Entire_Fleet']: return React.createElement(WorldWidePage, null);
            case localeStringsCustomer['About']: return React.createElement(AboutPage, null);
        }
    };
    Application.prototype.componentWillUnmount = function () {
        this.serverRequest.abort();
        //window.removeEventListener('scroll', this.handleScroll);
    };
    Application.prototype.handleApplicationViewTabsChange = function (selectedPill) {
        this.setState({
            selectedPill: selectedPill
        });
    };
    return Application;
}(React.Component));
exports.Application = Application;
//# sourceMappingURL=App.js.map